import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Sidebarmenu from "../../Sidebar/Sidebarmenu";
import Header from "../Header/Header";
import "../Dashboard.css";
import remove from "../../../img/remove.png";
import editicon from "../../../img/editicon.png";

import right from "../../../img/Icon/right.svg";
import removeimg from "../../../img/removeimg.png";
import Refrach from "../../../img/clearimg.png";
import userprofilelist from "../../../img/noimg.png";
import multiuser from "../../../img/multiuser.png";
import user_side from "../../../img/Icon/Userside.svg";
import Modal from "react-modal";
import { getHijriParts } from "../../HijriCalendar/getHijriDate";
import { toast } from "react-toastify";
import Select from "react-select";
import axios from "axios";
import { useDispatch } from "react-redux";
import loadergif from '../../../img/landing/loader123.gif';
import { CSVLink } from 'react-csv';
import { isMobile } from "../../Helper/Helper";

import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
// import { Offcanvas } from 'bootstrap';
import {
  createUser,
  RegisteruserData,
  createRegisteruse,
  fetchUserData,
  fetchUsersData,
  fetchNotesUserData,
  getPortionList,
  getZoneList, api_url, fmb_schedule_url, user_management
} from "../../../Redux/Reducer/AuthReducer";
import { data } from "jquery";
import AWS from 'aws-sdk';
import { act } from "react";

AWS.config.update({
  accessKeyId: 'AKIAU3H7RLHX3WKU6DUS',
  secretAccessKey: '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',
  region: 'us-east-1',
});

const s3 = new AWS.S3();
const bucketName = 'fmb-images'


export default function Users() {
  const user_Role = localStorage.getItem("access_Role");
  const imgurl = "https://fmb-images.s3.amazonaws.com/images/"
  const access_id = localStorage.getItem("access_id");
  var token = localStorage.getItem("access_token");
  const dispatch = useDispatch();
  const [totalcount, setTotalCount] = useState('');
  const ref = React.useRef(null);
  const [loading, setLoading] = useState(true);
  const [src, setSrc] = React.useState('');
  const [item, setItem] = useState([]);
  const [image, setImage] = useState("");
  const [portionlist, setPortionList] = useState([]);
  const [zonedata, setZonedata] = useState([]);
  const [cleartype, setCleartype] = useState([]);
  const [portionid, setPortionid] = useState("");
  const [defaultportionid, setDefaultPortionid] = useState("");
  const [zoneid, setZoneid] = useState("");
  const [updateImage, setUpdateImage] = useState('');
  const [zonelistdata, setZonelistData] = useState("");
  const [name, setName] = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [number, setNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [id, setId] = useState('')
  const [isActive, setIsActive] = useState('')
  const [selectedOption, setSelectedOption] = useState("Manual");
  const [selectedValue, setSelectedValue] = useState([]);
  const [its, setIts] = useState("");
  const [notes, setNotes] = useState("");
  const [zoneSheetNotes, setZoneSheetNotes] = useState("");
  const [sortColumn, setSortColumn] = useState('created_at');
  const [sortOrder, setSortOrder] = useState('asc');
  const [previewImage, setPreviewImage] = useState(userprofilelist);
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [validationerror, setValidationerror] = useState(false);
  const [itslogin, setItsLogin] = useState('');
  const [roleid, setRoleId] = useState([]);
  const [roleidupdate, setRoleIdUpdate] = useState([]);
  const [selectedValueupdate, setSelectedValueUpdate] = useState([]);
  const [ragisterView, setRagisterView] = useState([]);
  // Per-dish portion overrides, keyed by `${dayIndex}_${dishIndex}` - only holds
  // entries the admin has actually changed this session (see buildDishPortions).
  const [dishPortionSelections, setDishPortionSelections] = useState({});
  const [registerationUserDetail, setRegisterationUserDetail] = useState([]);
  // The user's own default portion code (items.default_portion from the Users
  // list row) - all-register-user-menu's per-day items carry no fallback of
  // their own (no item.user), so this is the last resort when a day's
  // portion_type_code is "-1"/unset.
  const [registerationUserDefaultPortion, setRegisterationUserDefaultPortion] = useState(null);
  const [notesUsers, setNotesUsers] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifModalOpen, setNotifModalOpen] = useState(false);
  const [notifUser, setNotifUser] = useState(null);
  const [notifTitle, setNotifTitle] = useState("");
  const [notifBody, setNotifBody] = useState("");
  const [notifLoading, setNotifLoading] = useState(false);
  const [reportdata, setReportData] = useState([]);
  const [filters, setFilters] = useState({
    active: false,
    inactive: false,
    nonits: false,
    khidmatguzar: false,
  });

  const handleSendNotification = async () => {
    if (!notifTitle.trim() || !notifBody.trim()) {
      toast.error("Title and Body are required");
      return;
    }
    setNotifLoading(true);
    try {
      const res = await fetch(user_management + "/admin/send-notification", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          user_id: notifUser?.its_id,
          title: notifTitle,
          body: notifBody,
          data: {},
          topic: "",
          created_user: access_id,
        }),
      });
      const result = await res.json();
      if (result?.status === true) {
        toast.success("Notification sent successfully");
        setNotifModalOpen(false);
        setNotifTitle("");
        setNotifBody("");
        setNotifUser(null);
      } else {
        toast.error(result?.message || "Failed to send notification");
      }
    } catch (err) {
      toast.error("Error sending notification");
    } finally {
      setNotifLoading(false);
    }
  };

  const handleFilterChange = (filterName) => {
    setFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        [filterName]: !prevFilters[filterName],
      };
      fetchData(updatedFilters, 1); // Fetch users whenever filters change
      return updatedFilters;
    });
  };

  // const fetchUsers = async (currentFilters) => {
  //   const queryParams = new URLSearchParams();
  
  //   if (currentFilters.inactive) queryParams.append("inactive", "true");
  //   if (currentFilters.nonits) queryParams.append("nonits", "true");
  //   if (currentFilters.khidmatguzar) queryParams.append("khidmatguzar", "true");
  
  //   // Dispatch Redux action with query string
  //   await dispatch(fetchData(`?${queryParams.toString()}`));
  // };

  // Clean dish-name list for a schedule day - JSON.parse instead of the old
  // substring/split hack, so names with commas/quotes in them don't break.
  const parseMenuDishNames = (item) => {
    if (!item?.menu) return [];
    try {
      return JSON.parse(item.menu).filter((m) => m && m !== "");
    } catch (_) {
      return [];
    }
  };

  // all-register-user-menu returns `dishes` as an already-parsed array (unlike
  // `menu`, which is a JSON string) - handle both shapes defensively.
  const parseScheduleDishes = (item) => {
    if (!item?.dishes) return [];
    if (Array.isArray(item.dishes)) return item.dishes;
    try {
      const parsed = JSON.parse(item.dishes);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  };

  const stripDishBadge = (menuItem) =>
    menuItem.replace(/\s*\([^)]*\)/, "").trim().toLowerCase();

  const findDishMatch = (dishes, menuItem) => {
    const name = stripDishBadge(menuItem);
    return (
      dishes.find(
        (d) =>
          d.dish_name === menuItem ||
          stripDishBadge(d.dish_name || "") === name
      ) || null
    );
  };

  // "0"/"-1"/blank all mean "no portion actually chosen" (0 is the same
  // not-set sentinel buildDishPortions sends on submit; -1 is the day-level
  // "use my default" sentinel) - none of these should block falling through
  // to the next-best default, since ?? only treats null/undefined as empty.
  const isEmptyPortionCode = (code) =>
    code === null || code === undefined || code === "" ||
    code === 0 || code === "0" || code === -1 || code === "-1";

  // Falls back from the day-level portion to item.user (when the API response
  // includes it), then to the user's own default portion (fetched separately
  // from their Users-list row - all-register-user-menu's per-day items don't
  // carry this themselves) when the day-level code itself is unset.
  const resolveDayPortion = (item) => {
    if (!isEmptyPortionCode(item?.portion_type_code)) return item.portion_type_code;
    if (!isEmptyPortionCode(item?.user?.portion_type_code)) return item.user.portion_type_code;
    if (!isEmptyPortionCode(registerationUserDefaultPortion)) return registerationUserDefaultPortion;
    return null;
  };

  // Rice/roti dishes that the schedule allows skipping entirely are handled by
  // the existing day-level Rice/Roti toggles below, not a per-dish portion -
  // everything else gets its own portion selector.
  // "Tortilla Soup" isn't a roti/bread dish despite containing "tortilla".
  const isRotiDishName = (name) =>
    !name.includes("tortilla soup") && (
    name.includes("roti") || name.includes("naan") || name.includes("tacos") ||
    name.includes("paratha") || name.includes("manda") || name.includes("bread") ||
    name.includes("batura") || name.includes("puri") || name.includes("toast") ||
    name.includes("tortilla") || name.includes("roll") || name.includes("pita") ||
    name.includes("bun") || name.includes("croissant") || name.includes("gakhar") ||
    name.includes("rusk") || name.includes("biscuit") || name.includes("porotta") ||
    name.includes("bagel"));
  const isRiceDishName = (name) =>
    name.includes("rice") || name.includes("chawal") || name.includes("khichdi");
  const isSkippableRiceRotiDish = (item, menuItem) => {
    const name = stripDishBadge(menuItem);
    return (
      (isRotiDishName(name) && item?.allow_skip_roti == 1) ||
      (isRiceDishName(name) && item?.allow_skip_rice == 1)
    );
  };

  // Per-dish portion overrides only travel in the submit payload for a day when
  // the admin actually changed at least one dish's portion - otherwise the day
  // keeps registering with whatever it already had (no dish_portions key sent).
  const buildDishPortions = (item, dayIndex) => {
    if (item?.schedule_type === "MIQAAT") return undefined;
    const menuItems = parseMenuDishNames(item);
    const dishes = parseScheduleDishes(item);

    let hasChanged = false;
    const portionsArray = menuItems.map((menuItem, dishIdx) => {
      const dish = findDishMatch(dishes, menuItem);
      const dpKey = `${dayIndex}_${dishIdx}`;
      const overrideCode = dishPortionSelections[dpKey];
      const apiPortionCode = dish?.portion_type_code ?? null;
      const finalCode = overrideCode !== undefined ? overrideCode : apiPortionCode;

      if (
        overrideCode !== undefined &&
        String(overrideCode) !== String(apiPortionCode)
      ) {
        hasChanged = true;
      }

      return {
        schedule_dish_id: dish?.schedule_dish_id ?? null,
        dish_id: dish?.dish_id ?? null,
        portion_type_code: finalCode != null ? parseInt(finalCode) : 0,
      };
    });

    return hasChanged ? portionsArray : undefined;
  };

  const handleSubmituser = async (e) => {
    e.preventDefault();
    const obj = ragisterView.map((item, i) => ({
      schedule_id: item.schedule_id,
      user_id: item.user_id,
      want_rice: item.allow_skip_rice !== "0" ? (item.want_rice == -1 ? 0 : item.want_rice) : -1,
      want_roti: item.allow_skip_roti !== "0" ? (item.want_roti == -1 ? 0 : item.want_roti ) : -1,
      want_mithas: item.allow_skip_mithas !== "0" ? (item.want_mithas == -1 ? 0 : item.want_mithas ) : -1,
      is_active: item.is_active ? 1 : 0,
      pickup_location_code: item.pickup_location_code,
      // MIQAAT RSVP codes (11-20) are a different scale than FMB Thali portion
      // codes (1-4), so the FMB "-1 -> user's default portion" resolution
      // doesn't apply there.
      portion_type_code: item.schedule_type === "MIQAAT" ? item.portion_type_code : resolveDayPortion(item),
      created_user: access_id,
      source: item.source != 0 ? item.source : "",
      ...(() => {
        const dp = buildDishPortions(item, i);
        return dp ? { dish_portions: dp } : {};
      })(),
    }));

    setIsSubmitting(true);
    try {
      await dispatch(createRegisteruse(obj)).unwrap();
      closeModal();
    } catch (error) {
      console.error("Error updating registration:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleSort = (columnName) => {
    if (sortColumn === columnName) {
      setSortOrder((prevSortOrder) => (prevSortOrder === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortColumn(columnName);
      setSortOrder('asc');
    }
  };

  const getSortIcon = (columnName) => {
    if (sortColumn === columnName) {
      return sortOrder === 'asc' ? <i className="fa fa-sort-up"></i> : <i className="fa fa-sort-down"></i>;
    }
    return null;
  };



  let sortedUser;

  if (item && typeof item === 'object') {
    const itemArray = Object.values(item);
    sortedUser = itemArray.sort((a, b) => {
      if (sortColumn === 'Name') {
        const nameA = (a.first_name || '').toLowerCase();
        const nameB = (b.first_name || '').toLowerCase();

        if (nameA < nameB) {
          return sortOrder === 'asc' ? -1 : 1;
        }
        if (nameA > nameB) {
          return sortOrder === 'asc' ? 1 : -1;
        }
        return 0;
      }
      // Handle sorting for other columns if needed
      return 0;
    });
  } else {
    // Handle the case when 'item' is null or undefined
  }

  function convertDateForIos(date) {
    var arr = date.split(/[- :]/);
    date = new Date(arr[2], arr[0]-1, arr[1]);
    return date;
}


  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }
  function closeModal() {
    setIsOpen(false);
  }

  function afterOpenModal() {}

  const handlezoneIdChange = (index, label) => {
    const updatedzone = ragisterView.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          pickup_location_code: label,
        };
      }
      return item;
    });

    setRagisterView(updatedzone);
  };

  const handlezoneIdChange2 = (index, label) => {
    const updatedzone = ragisterView.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          portion_type_code: label,
        };
      }
      return item;
    });

    setRagisterView(updatedzone);
  };


  const handleRotiChange = (e, index, isChecked) => {
    const { checked } = e.target;

    setRagisterView((prevuser) =>
      prevuser.map((item, i) =>
        i === index ? { ...item, want_roti: checked ? "1" : "0" } : item
      )
    );
  };
  const handleRiceChange = (e, index, isChecked) => {
    const { checked } = e.target;

    setRagisterView((prevuser) =>
      prevuser.map((item, i) =>
        i === index ? { ...item, want_rice: checked ? "1" : "0" } : item
      )
    );
  };

  const handleMithasChange = (e, index, isChecked) => {
    const { checked } = e.target;

    setRagisterView((prevuser) =>
      prevuser.map((item, i) =>
        i === index ? { ...item, want_mithas: checked ? "1" : "0" } : item
      )
    );
  };

  const handleSourceChange = (e, index) => {
    const sourceValue = e.target.value;
    setRagisterView((prevuser) =>
      prevuser.map((item, i) =>
        i === index ? { ...item, source: sourceValue } : item
      )
    );
  };

  const handleTHALIChange = (e, index, isChecked) => {
    const { checked } = e.target;

    setRagisterView((prevuser) =>
      prevuser.map((item, i) =>
        i === index ? { ...item, is_active: checked ? true : false } : item
      )
    );
  };


  const handleRadioChange = (event) => {
    if (event.target.value === "Auto") {
      setSelectedOption("Auto");
    } else if (event.target.value === "Manual") {
      setSelectedOption("Manual");
    }
  };
  const handleRadioChange2 = (event) => {
    setSelectedOption(event.target.value);
  };
  const onChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setSrc(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const handleNotesChange = (event) => {
    setNotes(event.target.value);
  };

  const handleZoneSheetNotesChange = (event) => {
    setZoneSheetNotes(event.target.value);
  };

  const handleRegisteruser = (requestData) => {
    dispatch(createRegisteruse(requestData));
  };


  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  let subtitle;
  const [RemoveIsOpen, setIsRemoveOpen] = React.useState(false);
  const [RemoveuserIsOpen, setIsRemoveuserOpen] = React.useState(false);
  function RemoveModal(e) {
    e.preventDefault();
    setIsRemoveOpen(true);
  }

  function RemoveOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function RemovecloseModal() {
    setIsRemoveOpen(false);
  }

  function RemoveuserModal() {
    setIsRemoveuserOpen(true);
  }


  const RemoveuserModaldata = () => {
    const requestBody = {
      user_id: id
    };


    fetch(user_management + 'admin/delete-user', {
      method: 'POST',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestBody),
    })
      .then(response => response.json())
      .then(data => {
        if (data?.status === true) {
          // Handle successful response
          // Update state or perform any necessary actions
          //   setCaterer(data.data);
          fetchData(filters, 1);
          toast.success(data?.message);
          RemoveusercloseModal()
        } else {
          // Handle error response
          toast.error(data?.message);
        }
      })
      .catch(error => {
        // Handle any errors that occur during the request
        console.error(error);
      });
  };
  function RemoveuserOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#AE8340" : null,
        boxShadow: isFocused ? "none" : "none",
        color: "#333333",
      };
    },
  };
  // Compact per-dish portion Select, sat inline next to the dish name.
  const dishPortionSelectStyles = {
    ...colourStyles,
    control: (styles) => ({ ...styles, minHeight: 30, height: 30 }),
    valueContainer: (styles) => ({ ...styles, height: 30, padding: "0 6px" }),
    indicatorsContainer: (styles) => ({ ...styles, height: 30 }),
  };
  function RemoveusercloseModal() {
    setIsRemoveuserOpen(false);
  }
  const getUserData = () => {

    dispatch(fetchUserData()).then((res) => {
      console.log(res, "dddddaaa");
      if (res?.payload?.status === true) {
        setItem(res?.payload?.data);

      } else {
        toast.error(res?.payload?.message);
      }
    });
  };
  const portionList = () => {
    dispatch(getPortionList()).then((res) => {
      if (res?.payload?.status === true) {
        setPortionList(res?.payload?.data);
        // console.log('',res.payload.data)
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };
  const zoneList = () => {
    dispatch(getZoneList()).then((res) => {
      console.log(res, "res");
      if (res?.payload?.status === true) {
        setZonedata(res?.payload?.data);
        // console.log('',res.payload.data)
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };

  let portionListData = [];
  portionListData = portionlist?.map((item) => ({
    label: item.portion_type_name,
    value: item.portion_type_code,
  }));

  // Miqaat portion list data for Miqaat days
  const miqaatPortionListData = [
    { label: "1 Person", value: "11" },
    { label: "2 People", value: "12" },
    { label: "3 People", value: "13" },
    { label: "4 People", value: "14" },
    { label: "5 People", value: "15" },
    { label: "6 People", value: "16" },
    { label: "7 People", value: "17" },
    { label: "8 People", value: "18" },
    { label: "9 People", value: "19" },
    { label: "10 People", value: "20" },
  ];

  let zoneListData = [];
  zoneListData = zonedata?.map((item) => ({
    label: item.pickup_location_name,
    value: item.pickup_location_code,
  }));

  const fetchData = (filters, pageNumber = 1) => {
    setLoading(true); // Set loading to true before making the API call
    dispatch(fetchUserData({...filters, page: pageNumber}))
      .then((res) => {
        setItem(res?.payload?.data);
        setTotalPages(res?.payload?.totalPages);
        setTotalCount(res?.payload?.count);
      })
      .catch((error) => {
        // Handle errors if the fetch operation fails.
        // You can display an error message or handle it as needed.
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false when data fetching is complete
      });
  };

  const fetchUsers = () => {
    dispatch(fetchUsersData())
      .then((res) => {
        setReportData (res?.payload?.data);
      })
      .catch((error) => {
        // Handle errors if the fetch operation fails.
        // You can display an error message or handle it as needed.
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false when data fetching is complete
      });
  };

  const fetchNotesUser = () => {
    setLoading(true); // Set loading to true before making the API call

    dispatch(fetchNotesUserData())
      .then((res) => {
        setItem(res?.payload?.data);
        setTotalCount(res?.payload?.count);
      })
      .catch((error) => {
        // Handle errors if the fetch operation fails.
        // You can display an error message or handle it as needed.
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false when data fetching is complete
      });
  };

  useEffect(() => {
    fetchData(filters);
    fetchUsers();
    portionList();
    zoneList();
  }, []);
  // const offcanvasRef = useRef(null);

  // code for ITS validation start
  const handleChangeits = (e) => {
    const input = e.target.value;
    setIts(input);

    // Regular expression to check if the input contains exactly 9 digits
    // const nineDigitsPattern = /^\d{9}$/;
    // setValidationerror(!nineDigitsPattern.test(input));
  };
  const nineDigitsPattern = /^\d{9}$/;
  const mobilenumberregex = /^\d{10}$/;

  // code for ITS validation End



  const handleSubmit = (e) => {
    e.preventDefault();
    // const data = new FormData();
    e.preventDefault();
    // Perform validation checks on form fields


    // data.append("its_id", its);
    // data.append("first_name", name);
    // data.append("last_name", last_name);
    // data.append("designation", address);
    // data.append("phone", phone);
    // data.append("pickup_location_code", zoneid.value);
    // data.append("email", email);
    // data.append("portion_type_code", portionid.value);
    // data.append("is_fridge_allowed", "1");
    // data.append("sector", "new");
    // data.append("sub_sector", "name");
    // data.append("roles", selectedValue);
    // data.append("want_rice", "1");
    // data.append("want_roti", "1");
    // data.append("is_super_user", "1");
    // data.append("is_active", "1");
    // data.append("created_user", "");
    // data.append("user_profile", updateImage);
    // data.append("source", "web");
    // data.append("role_id", roleid);
    // data.append("booking_type", selectedOption);
    // data.append("its_login", itslogin.label);
    // data.append("default_portion", defaultportionid.value);
    // Add Validation 
    ;


    if (!name ||
      !its ||
      !last_name ||
      !itslogin.label ||
      !defaultportionid ||
      !zoneid ||
      !portionid
      // !mobilenumberregex.test(phone)
      // !nineDigitsPattern.test(its)
    ) {
      setValidationerror(true)
      return false
    }
    else {
      const postdata = {
        its_id: its,
        first_name: name,
        last_name: last_name,
        designation: address,
        phone: phone,
        pickup_location_code: zoneid.value,
        email: email,
        portion_type_code: portionid.value,
        is_fridge_allowed: "1",
        sector: "new",
        sub_sector: "name",
        roles: selectedValue,
        want_rice: "1",
        want_roti: "1",
        want_mithas: "1",
        is_super_user: "1",
        is_active: "1",
        created_user: access_id,
        file: updateImage,
        source: "Web",
        role_id: roleid,
        booking_type: selectedOption,
        its_login: itslogin.label,
        default_portion: defaultportionid.value,

      }
      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      };
      axios
        .post(user_management + "admin/create-user", postdata, config, {})
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            fetchData(filters);
            setName('');
            setLastName('')
            setIts('');
            setNotes('');
            setZoneSheetNotes('');
            setPhone('');
            setAddress('');
            setZoneid('');
            setPortionid('');
            setEmail('');
            setDefaultPortionid('');
            // setSelectedOption('');
            // setSelectedValue('');
            setEmail('');
            setUpdateImage('')
            setPreviewImage(userprofilelist)
            setRoleId('')
            setItsLogin([])
            setSelectedValue([])
            // const offcanvas = offcanvasRef.current;
            // if (offcanvas) {
            //   const bootstrapOffcanvas = new Offcanvas(offcanvas); // Using the imported Offcanvas component
            //   bootstrapOffcanvas.hide();
            // }
            const modal_close_btn2 = document.getElementById("modal_close_btn").click();

            setValidationerror(false)

          } else {
            toast.error(res?.data?.message);
          }
        });
      // setName("");
      // setPhone("");
      // setAddress("");
    };
  }


  const reset = () => {
    setName('');
    setLastName('')
    setIts('');
    setNotes('');
    setZoneSheetNotes('');
    setPhone('');
    setAddress('');
    setZoneid('');
    setPortionid('');
    setEmail('');
    setDefaultPortionid('');
    // setSelectedOption('');
    // setSelectedValue('');
    setEmail('');
    setUpdateImage('')
    setPreviewImage(userprofilelist)
    setRoleId('')
    setItsLogin([])
    setSelectedValue([])
  }
  const handleupdateSubmit = (e) => {
    e.preventDefault();
    // const data = new FormData();
    // data.append("its_id", its);
    // data.append("first_name", name);
    // data.append("last_name", last_name);
    // data.append("designation", address);
    // data.append("phone", phone);
    // data.append("pickup_location_code", zoneid);
    // data.append("email", email);
    // data.append("portion_type_code", portionid);
    // data.append("is_fridge_allowed", "1");
    // data.append("sector", "new");
    // data.append("sub_sector", "");
    // data.append("roles", selectedValueupdate);
    // data.append("want_rice", "1");
    // data.append("want_roti", "1");
    // data.append("is_super_user", "1");
    // data.append("is_active", "1");

    // data.append("user_profile", updateImage);
    // data.append("source", "web");
    // data.append("updated_user", "user");
    // data.append("role_id", roleidupdate);
    // data.append("booking_type", selectedOption);
    // data.append("its_login", itslogin);
    // data.append("default_portion", defaultportionid);


    // Add Validation 
    if (!name ||
      !its ||
      !last_name ||
      !itslogin ||
      ! defaultportionid ||
      !zoneid ||
      !portionid
    ) {
      setValidationerror(true)
      return false
    }
    else {
      const postdata = {
        id: id,
        its_id: its,
        first_name: name,
        last_name: last_name,
        designation: address,
        phone: phone,
        pickup_location_code: zoneid,
        email: email,
        portion_type_code: portionid,
        is_fridge_allowed: "1",
        sector: "new",
        sub_sector: "",
        roles: [selectedValueupdate],
        want_rice: "1",
        want_roti: "1",
        want_mithas: "1",
        is_super_user: "1",
        is_active: isActive == '1' ? 1 : 0,
        file: updateImage,
        source: "Web",
        updated_user: '',
        role_id: [roleidupdate],
        booking_type: selectedOption,
        its_login: itslogin,
        default_portion: defaultportionid,
        notes: notes,
        zone_sheet_notes: zoneSheetNotes
      }

      const config = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      };
      axios
        .put(user_management + `admin/update-user/${id}`, postdata, config, {})
        .then((res) => {
          if (res?.data?.status === true) {
            toast.success(res?.data?.message);
            fetchData(filters);
            console.log('sss', res?.data)
            setName('');
            setLastName('')
            setIts('');
            setPhone('');
            setAddress('');
            setZoneid('');
            setPortionid('');
            setDefaultPortionid('');
            setEmail('');
            setNotes('');
            setZoneSheetNotes('');
            // }

            // const offcanvas = document.getElementById("offcanvasRight_update");
            // if (offcanvas) {
            //   offcanvas.classList.remove("show"); // Remove the "show" class from the off-canvas element



            // }

            const modal_close = document.getElementById("modal_close_btn2").click();
            setValidationerror(false)
          } else {
            toast.error(res?.data?.message);
          }
        });

    };
  }

  // The user's roles/role_id can come back from the API as a comma-separated
  // string (or null for a user with none) rather than an actual array -
  // normalizes either into a real array so a role toggle can safely spread/
  // filter it instead of (as handleupdateboxChange used to) resetting to []
  // and silently dropping every other already-selected role.
  const toRoleArray = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string" && value.trim() !== "") {
      return value.split(",").map((v) => v.trim()).filter(Boolean);
    }
    return [];
  };

  const handleCheckboxChange = (value, id) => {
    setSelectedValue((prevSelectedValue) => {
      const current = toRoleArray(prevSelectedValue);
      if (current.includes(value)) {
        return current.filter((item) => item !== value);
      } else {
        return [...current, value];
      }
    });

    setRoleId((prevSelectedValue) => {
      const current = toRoleArray(prevSelectedValue);
      if (current.includes(id)) {
        return current.filter((item) => item !== id);
      } else {
        return [...current, id];
      }
    });

    // You can access the 'id' here and use it as needed
    console.log(`Checkbox with ID '${id}' was clicked.`);
  };


  const handleupdateboxChange = (value, id) => {
    setSelectedValueUpdate((prevSelectedValue) => {
      const current = toRoleArray(prevSelectedValue);
      if (current.includes(value)) {
        return current.filter((item) => item !== value);
      } else {
        return [...current, value];
      }
    });

    setRoleIdUpdate((prevRoleIds) => {
      const current = toRoleArray(prevRoleIds);
      if (current.includes(id)) {
        return current.filter((roleId) => roleId !== id);
      } else {
        return [...current, id];
      }
    });
  };


  const ChangeStatusActive = (user_id) => {
    setLoading(true);
    fetch(user_management + `admin/user/activate/${user_id}`, {
      method: 'PUT',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data?.status == true) {
          toast.success(data?.message);
          handleSearch()
        } else {
          // Handle error response
          toast.error(data?.message);
        }
      })
      .catch(error => {
        // Handle any errors that occur during the request
        console.error(error);
      }) .finally(() => {
        setLoading(false); // Set loading state to false after data has been fetched or in case of an error
      });

  };

  const ChangeStatusInActive = (user_id) => {
    setLoading(true);
    fetch(user_management + `admin/user/inactivate/${user_id}`, {
      method: 'PUT',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("access_token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data?.status == true) {
          toast.success(data?.message);
          handleSearch()
        } else {
          // Handle error response
          toast.error(data?.message);
        }
      })
      .catch(error => {
        // Handle any errors that occur during the request
        console.error(error);
      }) .finally(() => {
        setLoading(false); // Set loading state to false after data has been fetched or in case of an error
      });

  }
  
  const allowedFileTypes = ['jpg', 'jpeg', 'png', 'gif'];
  const handleChangeImg = (e) => {
    const file = e.target.files[0];
    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();

    if (!allowedFileTypes.includes(fileExtension)) {
      console.error('Invalid file type. Allowed types are:', allowedFileTypes.join(', '));

      toast.error('Invalid file type. Allowed types are:', allowedFileTypes.join(', '));
      return;
    }



    const params = {
      Bucket: bucketName,
      Key: `images/${file.name}`,
      Body: file,
      ACL: 'public-read',
    };

    s3.upload(params, (err, data) => {
      if (err) {
        console.error('Error uploading image to S3:', err);
      } else {
        console.log('Image uploaded successfully:', data.Location);

        const parts = data.Location.split('/');
        const fileName = decodeURIComponent(parts[parts.length - 1]);
        const previewURL = URL.createObjectURL(file);

        setUpdateImage(fileName);
        setPreviewImage(previewURL);
      }
    });
  };


  const handleChangeImgUrl = (event) => {
    const file = event.target.files[0];

    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();

    if (!allowedFileTypes.includes(fileExtension)) {
      console.error('Invalid file type. Allowed types are:', allowedFileTypes.join(', '));

      toast.error('Invalid file type. Allowed types are:', allowedFileTypes.join(', '));
      return;
    }



    const params = {
      Bucket: bucketName,
      Key: `images/${file.name}`,
      Body: file,
      ACL: 'public-read',
    };

    s3.upload(params, (err, data) => {
      if (err) {
        console.error('Error uploading image to S3:', err);
      } else {
        console.log('Image uploaded successfully:', data.Location);
        // Set the image URL in your component's state for display




        const parts = data.Location.split('/');
        const fileName = decodeURIComponent(parts[parts.length - 1]);
        const previewURL = URL.createObjectURL(file);
        console.log(fileName);
        setUpdateImage(fileName);
        // Set the preview image URL in your component's state
        setImage(previewURL);
      }
    });

  };



  const dataget = (items) => {
    console.log ("dataget", items)
    setId(items.id);
    setImage(items.user_profile ? imgurl + items.user_profile : previewImage);
    setName(items.first_name);
    setLastName(items.last_name);
    setIts(items.its_id);
    setNotes(items.notes);
    setZoneSheetNotes(items.zone_sheet_notes);
    setPhone(items.phone);
    setAddress(items.designation);
    setZoneid(items.pickup_location_code);
    setPortionid(items.portion_type_code);
    setDefaultPortionid(items.default_portion);
    setItsLogin(items.its_login);
    setSelectedOption(items.booking_type);
    setSelectedValue(toRoleArray(items.roles));
    setEmail(items.email);
    setIsActive(items.is_active);
    setRoleIdUpdate(toRoleArray(items.role_id));
    setSelectedValueUpdate(toRoleArray(items.roles));

  };




  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = async () => {
    try {

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json", // Assuming you're sending form data
        Authorization: localStorage.getItem("access_token"),
      };
      const response = await fetch(user_management + `admin/search-user?user=${encodeURIComponent(searchQuery)}`
        , {
          method: "GET",
          headers: headers,
        });
      if (response.ok) {
        const data = await response.json();
        console.log('data:', data); // Check the structure of the received data
        if (data.data && Array.isArray(data?.data)) {
          setItem(data?.data);
          setTotalCount (data?.count);
          // Set the total number of pages
        } else {
          console.log('Invalid data format:', data?.data);
          setItem(data);
        }
      } else {
        console.log('Error: ', response?.status);
      }
    } catch (error) {
      console.log('Error: ', error);
    }
  };
  useEffect(() => {
    if (searchQuery) {
      handleSearch();
    }
    else {
      fetchData(filters);
    }
  }, [searchQuery]);


  const [totalPages, setTotalPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const handleFirstPage = () => {
    setCurrentPage(1);
    fetchData(filters, 1);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchData(filters, pageNumber);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    fetchData(filters, totalPages);
  };

  const handleToggleChange2 = (e) => {
    const newValue = notesUsers === "1" ? "" : "1";
    setNotesUsers(newValue);
    newValue ? fetchNotesUser() : fetchData(filters, 1);
  };

  const Registerviewdata = (id, user_detail, default_portion) => {
    setLoading(true);
    setRegisterationUserDetail(user_detail)
    setRegisterationUserDefaultPortion(default_portion ?? null)
    const queryParams = new URLSearchParams();
    queryParams.append("id", id);
    const data = {
      _id: id,
    };

    dispatch(RegisteruserData(data)).then((res) => {
      if (res?.payload?.status === true) {
        setRagisterView(res?.payload?.data);
        // Only clear local dish-portion overrides once the fresh data has actually
        // landed, so the UI never briefly falls back to the pre-edit default in between.
        setDishPortionSelections({});
        setLoading(false);
        openModal()
      } else {
        toast.error(res?.payload?.message);
        setLoading(false);
      }
    });
  };

  const PrintRegisterviewdata = (id, user_detail) => {
    setLoading(true);
    setRegisterationUserDetail(user_detail)
    const queryParams = new URLSearchParams();
    queryParams.append("id", id);
    const data = {
      _id: id,
    };

    dispatch(RegisteruserData(data)).then((res) => {
      if (res?.payload?.status === true) {
        setRagisterView(res?.payload?.data);
        setLoading(false);
        setTimeout(() => {
          Autoclickbutton();
        }, 1000);
      } else {
        toast.error(res?.payload?.message);
        setLoading(false);
      }
    });
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 10; // Maximum number of visible pages

    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };
  // const fetchDataList = async (page) => {
  //   try {
  //     const headers = {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       Authorization:localStorage.getItem("access_token"),
  //     };
  //     // Fetch data for the specified page
  //     const response = await fetch(user_management + `admin/get-user?page=${page}`, {
  //       method: "GET",
  //       headers: headers,
  //     });
  //     if (response.ok) {
  //       const responseData = await response.json();

  //       if (responseData && responseData?.data && Array.isArray(responseData?.data?.dish) && responseData.totalPages) {
  //         const { Item, totalPages } = responseData.data;

  //         // Set the fetched data and total pages
  //         setItem(Item);
  //         setTotalPages(totalPages);
  //       } else {
  //         setItem(responseData?.data);
  //         setTotalPages(responseData?.totalPages);
  //       }
  //     } else {
  //       console.log('Error fetching data:', response?.status);
  //     }
  //   } catch (error) {
  //     console.log('Error: ', error);
  //   }
  // };

  // useEffect(() => {
  //   fetchDataList(currentPage); // Fetch data for the initial page
  // }, []);



  const ItsListData = [
    { value: "1", label: "Yes" },
    { value: "2", label: "No" },
  ];
  const userlist = totalcount ? totalcount : '';
  const formatPhoneNumber = (input) => {
    // Remove all non-numeric characters from the input
    const numericValue = input.replace(/\D/g, '');

    // Apply the desired format (###-###-####)
    const formattedNumber = numericValue
      .slice(0, 10) // Limit to 10 digits (###-###-####)
      .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

    return formattedNumber;
  };

  const handlePhoneChange = (e) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    setPhone(formattedValue);
  };

  const handlePhoneChange2 = (e) => {
    const formattedValue = formatPhoneNumber(e.target.value);
    setPhone(formattedValue);
  };

  var dateName = function (date) {

    var arr = date.split(/[- :]/);

    var yyyy = arr[2]
    var mm = arr[0]
    var dd = arr[1]

    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var dayNames = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    var today = new Date(yyyy, mm - 1, dd);
    var dd = today.getDate();
    var dayname = dayNames[today.getDay() - 1];
    var mmName = monthNames[today.getMonth()];
    var yyyy = today.getFullYear();
    var fullDate = dayname + " - " + mm + "/" + dd + "/" + yyyy;
    return fullDate;
  };

  const csvData = reportdata.map((items) => {

    return {
        ITSNUMBER: items.its_id,
        firstname: items.designation+' '+items.first_name +' '+items.last_name,
        phone: items.phone,
        portionName: items.portion_type_name,
        defaultPortionName: items.default_portion_type_name,
        zone: items.pickup_location_name,
        itsLogin: items.its_login,
        active: items.is_active,
        notes: items.notes,
    };
});


const csvHeaders = [
    { label: "ITS Number", key: "ITSNUMBER" },
    { label: "User Name", key: "firstname" },
    { label: "Phone", key: "phone" },
    { label: "Portion Size", key: "portionName" },
    { label: "Default Portion Size", key: "defaultPortionName" },
    { label: "Zone", key: "zone" },
    { label: "Active", key: "active" },
    { label: "Its Login", key: "itsLogin" },
    { label: "Notes", key: "notes" },
];

const reportFileName = "All-FMB-Users.csv" 

  const styles = StyleSheet.create({
    zonesheetsection: {
      marginTop: 20,
      marginBottom: 5,
      marginLeft: 0,
      marginRight: 10,
    },

    zonesheetBottomsection: {
      marginTop: 2,
      marginBottom: 5,
      marginLeft: 0,
      marginRight: 10,
    },

    ingrediantsection: {
      marginBottom: 5,
      marginLeft: 10,
      marginRight: 10,
    },
    columnheading: {
      marginBottom: 10,
      marginTop: 10
    },
    ingrediantOuterView: {
      flexDirection: "column",
      marginTop: 20,
      marginLeft: 35,
      marginBottom: 50,
      // backgroundColor: 'yellow',
      maxWidth: "100%"
    },
    page: {
      flexDirection: "row",
      backgroundColor: "#FFF",
      marginTop: 10,
    },

    zoneSection: {
      margin: 10,
      padding: 10,
      marginLeft: 20,
      flexGrow: 1,
    },

    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    table: {
      display: "table",
    },
    tableRow: {
      flexDirection: "row",
      width: 400,
    },
    tableMainCell: {
      borderColor: "#000",
      borderWidth: 1,
      borderRight: "none",
      padding: 5,
      textAlign: "center",
    },

    tableCell: {
      borderColor: "#000",
      borderWidth: 1,
      borderRight: "none",
      padding: 5,
      textAlign: "center",
      width: 600,
    },
    tableCellBottom: {
      borderColor: "#000",
      borderWidth: 1,
      marginLeft: -1,
      padding: 5,
      textAlign: "center",
    },


    tableZoneCell: {
      borderColor: "#000",
      borderWidth: 1,
      borderRight: "none",
      padding: 5,
      textAlign: "center",
      width: 1200,
    },
    tableZoneCellBottom: {
      borderColor: "#000",
      borderWidth: 1,
      padding: 5,
      textAlign: "center",
    },


    newApp: {
      flexGrow: 1,
      borderColor: "#000",
      borderWidth: 1,
      padding: 5,
      textAlign: "center",
    },

    newBottomApp: {
      flexGrow: 1,
      borderColor: "#000",
      borderWidth: 1,
      padding: 5,
      marginLeft: -1,
      textAlign: "center",
    },

    newMainCell: {
      flexGrow: 1,
      borderColor: "#000",
      borderWidth: 1,
      padding: 5,
      borderTop: "none",
      textAlign: "center",
    },

    newCell: {
      flexGrow: 1,
      borderColor: "#000",
      borderWidth: 1,
      padding: 5,
      borderTop: "none",
      marginLeft: -1,
      textAlign: "center",
    },

    dateCellMain: {
      flexGrow: 1,
      borderColor: "#000",
      borderWidth: 1,
      padding: 5,
      textAlign: "right",
    },

    dateCellItem: {
      width: "210%",
    },

    tableSellMain: {
      borderColor: "#000",
      borderWidth: 1,
      borderTop: "none",
      borderRight: "none",
      padding: 5,
    },

    tableRightMain: {
      width: "90%",
      maxWidth: "21%",
    },

    tableSellIng: {
      borderColor: "#000",
      borderWidth: 1,
      borderTop: "none",
      borderRight: "none",
      padding: 5,
    },

    tableSellZoneName: {
      borderColor: "#000",
      borderWidth: 1,
      borderTop: "none",
      borderRight: "none",
      padding: 5,
      fontSize: 10,
      textAlign: "left",
      width: 600
    },

    tableSell: {
      borderColor: "#000",
      borderWidth: 1,
      borderTop: "none",
      borderRight: "none",
      padding: 5,
      fontSize: 10,
      textAlign: "center",
      width: 600
    },

    tableMenu: {
      borderColor: "#000",
      borderWidth: 1,
      borderTop: "none",
      borderRight: "none",
      padding: 5,
      fontSize: 9,
      width: 600
    },

    columnIngredientHeader: {
      fontSize: 10,
      color: "#000",
      marginLeft: 50,
      marginTop: 30
    },
    columnHeader: {
      fontSize: 10,
      color: "#000",
    },
    tableWidth: {
      width: "110%",
      maxWidth: "24%",
    },

    tableZoneNameWidth: {
      width: "90%",
      maxWidth: "39%",
    },

    tableCommentswidth: {
      width: "110%",
      maxWidth: "25%",
    },


    tablePortionWidth: {
      width: "110%",
      maxWidth: "18%",
    },

    tablePhoneWidth: {
      width: "110%",
      maxWidth: "20%",
    },

    tableWidth: {
      width: "110%",
      maxWidth: "24%",
    },

    tableBottomWidth: {
      width: "110%",
      maxWidth: "14%",
    },

    tableZoneBottomWidth: {
      width: "110%",
      maxWidth: "24%",
    },


    tableWidthZonePortion: {
      width: "100%",
      maxWidth: "16%",
    },

    tableWidthRiceRoti: {
      width: "100%",
      maxWidth: "7%",
    },

    tableWidthThaali: {
      width: "100%",
      maxWidth: "10%",
    },

    tableInd: {
      width: "110%",
      maxWidth: "19%",
    },

    tabletdmenuItem: {
      maxWidth: "22%",
    },
    tabletdsubmenuItem: {
      width: "110%",
      maxWidth: "13%",
    },

    tableRight: {
      width: "110%",
      maxWidth: "51%",
    },

    tableMenuRight: {
      maxWidth: "320%",
      width: 1450,
    },

    textMainCell: {
      marginLeft: 80,
    },

    textDateCell: {
      marginLeft: 52,
      width: 100
    },

    textIngCell:{
      marginLeft: -15,
    },

    textQtyCell:{
      marginLeft: -7,
    },

    textUnitCell:{
      marginLeft: -5,
    },

    tableIngRight: {
      width: "110%",
      maxWidth: "55%",
    },

    tableName: {
      width: "110%",
      maxWidth: "28%",
    },

    tableRo: {
      width: "110%",
      maxWidth: "50%",
    },
    columnLeader: {
      fontSize: 10,
      color: "#000",
    },
    manData: {
      flexDirection: "row",
    },
    flowFloat: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 8,
      fontSize: 14,
      marginRight: 30,
      width: 560
    },
    labelItem: {
      fontWeight: "bold", // Ensure fontWeight is applied within labelItem style
    },
  });
  const styleslist = StyleSheet.create({
    page: {
      display: "flex",
      flexDirection: "row",
      fontWeight: "bold",
      flexWrap: "wrap",
      marginRight: 15,
      marginLeft: 15,
      // justifyContent: 'center', // Adjust as needed for spacing between items
      
    },
    labelSheet: {
      width: '145px',
      textAlign: "center",
      marginRight: 2,
      fontSize: 11,
      // backgroundColor: 'yellow',
      height: '72px',
      // borderColor: 'black',
      // borderWidth: 1
    },

    fatehaSheet: {
      width: "10%",
      textAlign: "center",
      marginBottom: 5,
      marginTop: 2,
      fontSize: 10,
    },

    labelItem: {
      // Adjust to allocate space for 2 items per row with a little gap in between
      // backgroundColor: 'lightgreen',
      // marginTop:5,
      // borderColor: 'black',
      // borderWidth: 1,
      fontWeight: "bold", // Ensure fontWeight is applied within labelItem style

      // marginBottom: 1
    },

    labelItemText: {
      fontSize: 10,
    },
    noData: {
      textAlign: "center",
      fontSize: 10,
      marginTop: 5,
    },
  });


  const generatePDF = () => (
    <Document>
        <Page size="LETTER" style={styles.page}>
          <View style={styles.zoneSection}>
            <View style={[styles.flowFloat, styles.labelItem]}>
              {" "}
              <Text>{registerationUserDetail}</Text>
              {" "}
            </View>
            <View style={styles.table}>
              <View style={[styles.tableRow, styles.columnHeader]}>
                <View style={[styles.tableZoneCell, styles.tablePortionWidth]}>
                  <Text>Date</Text>
                </View>
                <View style={[styles.tableZoneCell, styles.tableZoneNameWidth]}>
                  <Text>Menu</Text>
                </View>
                <View style={[styles.tableZoneCell, styles.tableWidthZonePortion]}>
                  <Text>Portion</Text>
                </View>
                <View style={[styles.tableZoneCell, styles.tableWidthZonePortion]}>
                  <Text>Zone</Text>
                </View>
                <View style={[styles.tableZoneCell, styles.tableWidthRiceRoti]}>
                  <Text>Rice</Text>
                </View>
                <View style={[styles.tableZoneCell, styles.tableWidthRiceRoti]}>
                  <Text>Roti</Text>
                </View>
                <View style={[styles.tableZoneCell, styles.tableWidthThaali]}>
                  <Text>Thaali</Text>
                </View>
                <View style={[styles.tableCommentswidth, styles.newApp]}>
                  <Text>Comments</Text>
                </View>
                {/* <View style={[styles.tableCell,styles.tableWidth]  }><Text>Comments</Text></View> */}
              </View>
              {ragisterView?.map((itemall, idx) => (
                <View key={idx} style={styles.tableRow}>
                  <View
                    style={[
                      styles.tableSellZoneName,
                      styles.tablePortionWidth,
                      styles.columnLeader,
                    ]}
                    numberOfLines={2}
                    ellipsizeMode="tail"
                  >
                    <Text>
                      {itemall?.schedule_day}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.tableMenu,
                      styles.tableZoneNameWidth
                    ]}
                  >
                    {itemall?.menu &&
                    JSON.parse(itemall?.menu).map(
                      (menu, index) => (
                        <Text>
                         - {menu ? menu : "NA"}
                        </Text>
                      )
                    )}
                  </View>
                  <View
                    style={[
                      styles.tableSell,
                      styles.tableWidthZonePortion,
                      styles.columnLeader,
                    ]}
                  >
                    <Text>
                      {itemall?.portion_type_code == "-1" ? "-" : itemall?.portion_type_name}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.tableSell,
                      styles.tableWidthZonePortion,
                      styles.columnLeader,
                    ]}
                  >
                    <Text>
                      {itemall?.pickup_location_code == "-1" ? "-" : itemall?.pickup_location_name}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.tableSell,
                      styles.tableWidthRiceRoti,
                      styles.columnLeader,
                    ]}
                  >
                  { itemall.allow_skip_rice != "0" ?
                    <Text>
                     {itemall?.want_rice === 1 ? "Y" : itemall?.want_rice === 0 ? "N": "-"}
                    </Text>
                    :
                    <Text> - </Text>
                  }
                  </View>
                  <View
                    style={[
                      styles.tableSell,
                      styles.tableWidthRiceRoti,
                      styles.columnLeader,
                    ]}
                  >
                  {itemall.allow_skip_roti != "0" ?
                    <Text>
                      {itemall?.want_roti === 1
                        ? "Y"
                        : itemall?.want_roti === 0
                          ? "N"
                          : "-"}
                    </Text>
                    :
                    <Text> - </Text>
                  }
                  </View>
                  <View
                    style={[
                      styles.tableSell,
                      styles.tableWidthRiceRoti,
                      styles.columnLeader,
                    ]}
                  >
                  {itemall.allow_skip_mithas != "0" ?
                    <Text>
                      {itemall?.want_mithas === 1
                        ? "Y"
                        : itemall?.want_mithas === 0
                          ? "N"
                          : "-"}
                    </Text>
                    :
                    <Text> - </Text>
                  }
                  </View>
                  <View
                    style={[
                      styles.tableSell,
                      styles.tableWidthThaali,
                      styles.columnLeader,
                    ]}
                  >
                    <Text>
                      {itemall?.is_active === 1
                        ? "Y"
                        : itemall?.is_active === 0
                          ? "N"
                          : "-"}
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.newMainCell,
                      styles.tableCommentswidth,
                      styles.columnLeader,
                    ]}
                  >
                    <Text>
                      {(itemall?.source == "Mobile\r" || itemall?.source == "0") ? "" : itemall?.source}
                    </Text>
                  </View>
                </View>
              ))}
              </View>
            </View>
        </Page>
    </Document>
  );

  const userRegisterDataFileName =  "Registration_"+registerationUserDetail+".pdf"

  const buttonRef = useRef(null);

  const Autoclickbutton = () => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };


  return (
    <div>
      <Header />
      <div
        className="side_div_menu"
        style={{ display: "flex", height: "100%" }}
      >
        <Sidebarmenu />
        <section className="main_section">
          <div className="custam">
            <div className="main_section2">
              <div className="ExportInventory thali_section Thali_page">
                <div className="container-fluid">
                  <div className="thili_div">
                    <div className="Back-page">
                      {" "}

                      <h1 className="title_heading">
                        Users ({userlist ? userlist : ''})
                      </h1>{" "}
                    </div>
                    <PDFDownloadLink
                        document={generatePDF()}
                        fileName={userRegisterDataFileName}
                        className=""
                        id="modal_close_btn8"
                      >
                        {({ blob, url, loading, error }) =>
                          loading ? (
                            "Loading document..."
                          ) : (
                            <>
                              {" "}
                              <button className="btn" ref={buttonRef}>
                                
                              </button>
                              {/* {Autoclickbutton()} */}
                            </>
                          )
                        }
                      </PDFDownloadLink>
                      <div className="Thali_page_btn AddStandardInventory AddUnRegisteredText">
                          <img
                              src={user_side}
                              className="img-fluid"
                            />
                            &nbsp; &nbsp;
                          <label for="Standard">
                            Notes &nbsp; &nbsp;
                          </label>
                        <div className="onoffswitch">
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            className="onoffswitch-checkbox"
                            id="rice_check"
                            checked={notesUsers == "1"}
                            onChange={handleToggleChange2}
                          />
                          <label className="onoffswitch-label" for="rice_check">
                            <span className="onoffswitch-inner"></span>
                            <span className="onoffswitch-switch"></span>
                          </label>
                        </div>
                      </div>
                      <div className="filters">
                      <label>
                          <input
                            type="checkbox"
                            checked={filters.active}
                            onChange={() => handleFilterChange("active")}
                            style={{marginRight: '5px', marginTop: '5px'}}
                          />
                          <span className="thali_table">
                            Show Active Users
                          </span>
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            checked={filters.inactive}
                            onChange={() => handleFilterChange("inactive")}
                            style={{marginRight: '5px', marginTop: '5px'}}
                          />
                          <span className="thali_table">
                            Show Inactive Users
                          </span>
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            checked={filters.nonits}
                            onChange={() => handleFilterChange("nonits")}
                            style={{marginRight: '5px', marginTop: '5px'}}
                          />
                          Show Non-ITS Login Users
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            checked={filters.khidmatguzar}
                            onChange={() => handleFilterChange("khidmatguzar")}
                            style={{marginRight: '5px', marginTop: '5px'}}
                          />
                          Show Khidmatguzar Users
                        </label>
                      </div>
                    { (user_Role.includes("ADM") || user_Role.includes("ODM")) &&
                      <div className="Thali_page_btn">
                        <button
                          className="btn thali_btn"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasRight"
                          aria-controls="offcanvasRight"
                          onClick={reset}
                        >
                          Add New
                        </button>
                        &nbsp;
                        &nbsp; &nbsp;
                        <button className="btn thali_btn csvbtn">
                            <CSVLink data={csvData} headers={csvHeaders} filename={reportFileName}>
                                Export Data
                            </CSVLink>
                        </button>
                        {/* <button onClick={RemoveModal}>sss</button> */}
                      </div>
                    }
                  </div>
                </div>
                <div className="thali_count_list">
                  <div className="form-group has-search">
                    <span className="fa fa-search form-control-feedback"></span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by  Users Name"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>

                <div className="thali_table_user_section">
                  {loading ? (
                    // Render a loading indicator while data is being fetched
                    <div className='Loading-img'><img src={loadergif} className='' /></div>

                  ) : (
                    <div></div>
                  )
                  }
                  <table className="table table-bordered">
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col">
                          <span className="thali_table">ITS Number</span>
                        </th>
                        <th scope="col" onClick={() => handleSort('Name')}>
                          <span className="thali_table">
                            User Name &nbsp; &nbsp; &nbsp;
                            {getSortIcon('Name')}
                          </span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Email</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Phone NO.</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Pickup</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Portion</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Default Portion</span>
                        </th>
                        <th scope="col">
                          <span className="thali_table">Type</span>
                        </th>
                        {notesUsers &&
                            <th scope="col">
                              <span className="thali_table">Notes</span>
                            </th>
                        }
                        <th scope="col">
                          <span className="thali_table">Action</span>
                        </th>
                        {/* <th scope="col"><span className='thali_table'>Current Qty/Unit</span></th>
                                            <th scope="col"><span className='thali_table'>Order PKG COUNT/TYPE</span></th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {sortedUser?.map((items) => {
                        return (
                          <tr key={items.id}>
                            <th scope="row" data-label="ITS Number">
                              <ul className="thali_menu_list">
                                <li>{items.its_id ? items.its_id : "-"}</li>
                              </ul>
                            </th>
                            <th scope="row" data-label="Name">
                              <ul className="thali_menu_list">
                                <li>
                                  {/* <img
                                    src={
                                      items.user_profile
                                        ? imgurl + items.user_profile
                                        : imgurl + "noimg.png"
                                    }
                                    // src={userprofilelist}
                                    className="img-firud image-fit"
                                  /> */}
                                  {/* {items.designation ? items.designation : ""} {" "}    {items.first_name ? items.first_name : "-"}{" "}
                                  {items.last_name ? items.last_name : ""} */}

                                  {items.designation === "Bhai" ? (
                                    <span>
                                      {items?.first_name} {items?.designation} {items?.last_name}
                                    </span>
                                  ) : (
                                    <span>
                                      {items?.designation} {items?.first_name} {items?.last_name}
                                    </span>
                                  )}
                                &nbsp; &nbsp; &nbsp;
                                {items?.is_active == "0" && (
                                <span className="Draft_inactive_event">
                                  {items?.is_active == "0" ? "INACTIVE" : ""}
                                </span>
                              )}
                                &nbsp; &nbsp; &nbsp;
                                {(items?.notes != null && items?.notes != "") && (
                                <span className="Draft_notes_event">
                                  {items?.notes !== null ? "NOTES" : ""}
                                </span>
                              )}
                                </li>
                              </ul>
                            </th>
                            <th scope="row" data-label="Email">
                              <ul className="thali_menu_list">
                                <li>{items.email !== "NULL" ? items.email : "-"}</li>
                              </ul>
                            </th>

                            <th scope="row" data-label="Phone">
                              <ul className="thali_menu_list">
                                <li>{items.phone !== "NULL" ? items.phone : "-"}</li>
                              </ul>
                            </th>
                            <th scope="row" data-label="Pickup">
                              <ul className="thali_menu_list">
                                <li>
                                  {items.pickup_location_name
                                    ? items.pickup_location_name
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            <th scope="row" data-label="Portion">
                              <ul className="thali_menu_list">
                                <li>
                                  {items.portion_type_name
                                    ? items.portion_type_name
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            <th scope="row" data-label="Default Portion">
                              <ul className="thali_menu_list">
                                <li>
                                  {items.default_portion_type_name
                                    ? items.default_portion_type_name
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            <th scope="row" data-label="Type">
                              <ul className="thali_menu_list">
                                <li>
                                  {items.booking_type
                                    ? items.booking_type
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            {notesUsers &&
                              <th scope="row" data-label="Notes">
                                <ul className="thali_menu_list">
                                  <li>
                                    {items.notes
                                      ? items.notes
                                      : "-"}
                                  </li>
                                </ul>
                              </th>
                            }
                            <th scope="row" data-label="Action">
                              <ul className="thali_menu_list">
                                <li>
                                  <div className="dropdown action_btn">
                                    <button
                                      className="btn btn-secondary dropdown-toggle"
                                      type="button"
                                      id="dropdownMenuButton2"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i
                                        className="fa fa-ellipsis-h"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    <ul
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton2"
                                    >
                                      {/* <li>
                                        <a
                                          className="dropdown-item"
                                          onClick={() => RemoveuserModal(items)}
                                        >
                                          {" "}
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="20"
                                            viewBox="0 0 18 20"
                                            fill="none"
                                          >
                                            <path
                                              d="M3.47748 19.1493C3.01584 19.1493 2.61556 18.9804 2.27663 18.6427C1.93769 18.3049 1.76823 17.906 1.76823 17.4461V3.29769H1.49323C1.25283 3.29769 1.05079 3.21543 0.887127 3.05092C0.723444 2.8864 0.641602 2.68332 0.641602 2.44167C0.641602 2.20003 0.723444 1.99842 0.887127 1.83682C1.05079 1.67522 1.25283 1.59442 1.49323 1.59442H5.60465C5.60465 1.34987 5.68649 1.14579 5.85018 0.982191C6.01384 0.818608 6.21588 0.736816 6.45628 0.736816H11.5443C11.7842 0.736816 11.9871 0.819775 12.1531 0.985691C12.319 1.15161 12.4019 1.35452 12.4019 1.59442H16.5074C16.7478 1.59442 16.9498 1.67668 17.1135 1.84122C17.2772 2.00573 17.359 2.20881 17.359 2.45044C17.359 2.69209 17.2772 2.89371 17.1135 3.05529C16.9498 3.21689 16.7478 3.29769 16.5074 3.29769H16.2324V17.4461C16.2324 17.906 16.0629 18.3049 15.724 18.6427C15.385 18.9804 14.9848 19.1493 14.5231 19.1493H3.47748ZM3.47748 3.29769V17.4461H14.5231V3.29769H3.47748ZM6.09758 14.5461C6.09758 14.7694 6.17524 14.9582 6.33058 15.1125C6.48589 15.2668 6.67602 15.3439 6.90095 15.3439C7.12589 15.3439 7.31516 15.2668 7.46878 15.1125C7.62241 14.9582 7.69923 14.7694 7.69923 14.5461V6.17269C7.69923 5.94932 7.62057 5.75952 7.46325 5.60327C7.30594 5.44702 7.11481 5.36889 6.88988 5.36889C6.66494 5.36889 6.47666 5.44702 6.32503 5.60327C6.17339 5.75952 6.09758 5.94932 6.09758 6.17269V14.5461ZM10.3014 14.5461C10.3014 14.7694 10.38 14.9582 10.5374 15.1125C10.6947 15.2668 10.8858 15.3439 11.1107 15.3439C11.3357 15.3439 11.5249 15.2668 11.6786 15.1125C11.8322 14.9582 11.909 14.7694 11.909 14.5461V6.17269C11.909 5.94932 11.8309 5.75952 11.6748 5.60327C11.5187 5.44702 11.3276 5.36889 11.1014 5.36889C10.8753 5.36889 10.6854 5.44702 10.5318 5.60327C10.3782 5.75952 10.3014 5.94932 10.3014 6.17269V14.5461Z"
                                              fill="#777391"
                                            />
                                          </svg>
                                          &nbsp; &nbsp; &nbsp;Remove
                                        </a>
                                      </li> */}
                                      {(user_Role.includes("ADM") || user_Role.includes("ODM")) &&
                                      <li>
                                        <a
                                          onClick={() => dataget(items)}
                                          className="dropdown-item"
                                          href="#"
                                          data-bs-toggle="offcanvas"
                                          data-bs-target="#offcanvasRight_update"
                                          aria-controls="offcanvasRight_update"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="15"
                                            viewBox="0 0 19 15"
                                            fill="none"
                                          >
                                            <path
                                              d="M17.125 8.65L15.35 6.875L16.075 6.15C16.2135 6.01667 16.3898 5.95 16.6039 5.95C16.818 5.95 16.9917 6.01667 17.125 6.15L17.85 6.875C17.9833 7.01352 18.05 7.18982 18.05 7.4039C18.05 7.61797 17.9833 7.79167 17.85 7.925L17.125 8.65ZM9 15V13.225L14.275 7.95L16.05 9.725L10.775 15H9ZM0.75 9.75C0.335787 9.75 0 9.41421 0 9C0 8.58579 0.335786 8.25 0.75 8.25H6.75C7.16421 8.25 7.5 8.58579 7.5 9C7.5 9.41421 7.16421 9.75 6.75 9.75H0.75ZM0.75 5.625C0.335786 5.625 0 5.28921 0 4.875C0 4.46079 0.335786 4.125 0.75 4.125H11C11.4142 4.125 11.75 4.46079 11.75 4.875C11.75 5.28921 11.4142 5.625 11 5.625H0.75ZM0.75 1.5C0.335786 1.5 0 1.16421 0 0.75C0 0.335786 0.335786 0 0.75 0H11C11.4142 0 11.75 0.335786 11.75 0.75C11.75 1.16421 11.4142 1.5 11 1.5H0.75Z"
                                              fill="#777391"
                                            />
                                          </svg>{" "}
                                          &nbsp; &nbsp;Edit Details
                                        </a>
                                      </li>
                                      }
                                    { (user_Role.includes("ADM") || user_Role.includes("OPT") || user_Role.includes("ODM")) &&
                                      <li
                                            onClick={() =>
                                              Registerviewdata(
                                                items.id,
                                                items.its_id+" : "+items.designation+" "+items.first_name+" "+items.last_name,
                                                items.default_portion
                                              )
                                            }
                                          >
                                            <a
                                              className="dropdown-item"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="20"
                                                viewBox="0 0 30 30"
                                                fill="none"
                                              >
                                              <path
                                                    d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                                                    fill="#777391"
                                                  />
                                                  <path
                                                        d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                                                        fill="#777391"
                                                  />
                                                  <path
                                                        d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                                                        fill="#777391"
                                                  />
                                                  <path
                                                        d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                                                        fill="#777391"
                                                  />
                                                <path
                                                 d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                                                 fill="#777391"
                                                />
                                              </svg>{" "}
                                              &nbsp; &nbsp;Edit Registration
                                            </a>
                                          </li>
                                          }
                                          <li
                                            onClick={() =>
                                              PrintRegisterviewdata(
                                                items.id,
                                                items.its_id+" : "+items.designation+" "+items.first_name+" "+items.last_name
                                              )
                                            }
                                          >
                                            <a
                                              className="dropdown-item"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="30"
                                                height="24"
                                                viewBox="0 0 34 30"
                                                fill="#777391"
                                              >
                                               <path
                                              d="m17 14a1 1 0 0 1 -1 1h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 1 1zm-4 3h-5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zm9-6.515v8.515a5.006 5.006 0 0 1 -5 5h-10a5.006 5.006 0 0 1 -5-5v-14a5.006 5.006 0 0 1 5-5h4.515a6.958 6.958 0 0 1 4.95 2.05l3.484 3.486a6.951 6.951 0 0 1 2.051 4.949zm-6.949-7.021a5.01 5.01 0 0 0 -1.051-.78v4.316a1 1 0 0 0 1 1h4.316a4.983 4.983 0 0 0 -.781-1.05zm4.949 7.021c0-.165-.032-.323-.047-.485h-4.953a3 3 0 0 1 -3-3v-4.953c-.162-.015-.321-.047-.485-.047h-4.515a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3z"
                                              />
                                              </svg>{" "}
                                              Print Registration
                                            </a>
                                          </li>
                                          {(user_Role.includes("ADM") || user_Role.includes("ODM")) &&
                                          <li>
                                            <a
                                              className="dropdown-item"
                                              href="#"
                                              onClick={(e) => { e.preventDefault(); setNotifUser(items); setNotifTitle(""); setNotifBody(""); setNotifModalOpen(true); }}
                                            >
                                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                <path d="M20 4H4C2.897 4 2 4.897 2 6v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2-8 5-8-5h16zm0 12H4V8.868l8 5 8-5V18z" fill="#777391"/>
                                              </svg>{" "}
                                              &nbsp; &nbsp;Send Notification
                                            </a>
                                          </li>
                                          }
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </th>
                          </tr>
                        );
                      })}

                    </tbody>
                  </table>
                </div>
                {!notesUsers &&
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={handleFirstPage}>
                        First
                      </button>
                    </li>

                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                        Previous
                      </button>
                    </li>

                    {getPageNumbers().map((pageNumber) => (
                      <li
                        className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
                        key={pageNumber}
                      >
                        <button className="page-link pagebutton" onClick={() => handlePageChange(pageNumber)}>
                          {pageNumber}
                        </button>
                      </li>
                    ))}

                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                        Next
                      </button>
                    </li>

                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={handleLastPage}>
                        Last
                      </button>
                    </li>
                  </ul>
                </nav>
                }
              </div>
            </div>
          </div>
        </section>
      </div>

      <div
        className="offcanvas offcanvas-end Dishes_canvas vendor_canvas"
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            Add User{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="Dish_Name_list">
            <form className="row g-3" onSubmit={handleSubmit}>
              {/* <div className="col-md-12">
                <div className="Img_upload">
                  <img src={previewImage} className="img-firud uplode_img" />
                  <div>
                    <input
                      id="img_upload"
                      type="file"
                      className="vender_input"
                      name="image"
                      onChange={handleChangeImg}
                    />

                  </div>

                </div>
                {validationerror && updateImage === null &&
                  <p className="show_invalid_text" > Image is required</p>}
              </div> */}
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="ITS Number" className="form-label">
                    ITS Number
                  </label>
                  {/* <input
                    type="number"
                    placeholder="Enter ITS Number"
                    id="ITS number"
                    onChange={(e) => setIts(e.target.value)}
                    className={`${ validationerror && its.length == 10 ? "validation_valid form-control" : "form-control"}`}
                  /> */}
                  <input
                    type="number"
                    placeholder="Enter ITS Number"
                    id="itsNumber"
                    value={its}
                    onChange={handleChangeits}
                    // className={`${validationerror && !nineDigitsPattern.test(its) ? "validation_valid form-control" : "form-control"}`}
                    className="form-control"
                    // pattern="\d{9}"
                    title="Please enter exactly 9 digits."
                  />
                  {/* {
                    validationerror && its.length == 10 && 
                    <p className="show_invalid_text" >  ITS Number is containe Min Max 9 digit</p>
                  } */}
                  {
                    validationerror && !its &&
                    <p className="show_invalid_text" >ITS Number cannot be blank</p>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Addres" className="form-label">
                    Designation
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Designation"
                    className={"form-control"}
                    id="Addres"
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                  />
                  {/* {
                    validationerror && !address &&
                    <p className="show_invalid_text" >    Designation is required</p>
                  } */}
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Name" className="form-label">
                    {" "}
                    First Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter First Name"
                    id="Name"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    className={`${validationerror && !name ? "validation_valid form-control" : "form-control"}`}
                  />
                  {
                    validationerror && !name &&
                    <p className="show_invalid_text" >First Name is required</p>
                  }
                </div>
              </div>

              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Name" className="form-label">
                    {" "}
                    Last Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Last Name"
                    id="last Name"
                    onChange={(e) => setLastName(e.target.value)}
                    value={last_name}
                    className={`${validationerror && !last_name ? "validation_valid form-control" : "form-control"}`}
                  />
                  {
                    validationerror && !last_name &&
                    <p className="show_invalid_text" > Last Name is required</p>
                  }
                </div>
              </div>


              <div className="col-md-6">
                <div className="Form_box">
                  <label for="ContactPhone" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Phone Number"
                    // className={`${validationerror && !mobilenumberregex.test(phone) ? "validation_valid form-control" : "form-control"}`}
                    className="form-control"
                    id="ContactPhone"
                    onChange={handlePhoneChange}
                    value={phone}
                  />
                  {/* {
                    validationerror && !mobilenumberregex.test(phone) &&
                    <p className="show_invalid_text" >    Phone Number is required</p>
                  } */}
                </div>
              </div>

              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Zone" className="form-label">
                    Zone
                  </label>

                  <Select
                    options={zoneListData}
                    className={`${validationerror && !zoneid ? "validation_valid dropdown" : "dropdown"}`}
                    placeholder="Select Zone"
                    id="inputrice"
                    styles={colourStyles}
                    value={zoneid}
                    defaultValue={cleartype}

                    onChange={(e) => setZoneid(e)}
                    isClearable
                    hideSelectedOptions={false}
                  />
                  {
                    validationerror && !zoneid &&
                    <p className="show_invalid_text" >Zone is required</p>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Portion" className="form-label">
                    Portion
                  </label>
                  <Select
                    options={portionListData}
                    className={`${validationerror && !portionid ? "validation_valid dropdown" : "dropdown"}`}
                    placeholder="Select Portion"
                    id="inputrice"
                    styles={colourStyles}
                    value={portionid}
                    defaultValue={cleartype}
                    onChange={(e) => setPortionid(e)}
                    isClearable
                    hideSelectedOptions={false}
                  />
                  {
                    validationerror && !portionid &&
                    <p className="show_invalid_text" >Portion is required</p>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    placeholder=" Enter Email Address"
                    className={"form-control"}
                    // className={`${validationerror && !email ? "validation_valid  form-control" : "form-control"}`}
                    id="Addres"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                  {/* {
                    validationerror && !email &&
                    <p className="show_invalid_text" >   Email is required</p>
                  } */}
                </div>
              </div>

              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Portion" className="form-label">
                    Default Portion
                  </label>
                  <Select
                    options={portionListData}
                    // className={`${validationerror && !portionid ? "validation_valid dropdown" : "dropdown"}`}
                    className="dropdown"
                    placeholder="Select Default Portion"
                    id="inputrice"
                    styles={colourStyles}
                    value={defaultportionid}
                    defaultValue={cleartype}
                    onChange={(e) => setDefaultPortionid(e)}
                    isClearable
                    hideSelectedOptions={false}
                  />
                  {
                    validationerror && !defaultportionid &&
                    <p className="show_invalid_text" >Default Portion is required</p>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Portion" className="form-label">
                    ITS LOGIN
                  </label>
                  <Select
                    options={ItsListData}
                    // className={`${validationerror && !portionid ? "validation_valid dropdown" : "dropdown"}`}
                    className="dropdown"
                    placeholder="Select ITS"
                    id="inputrice"
                    styles={colourStyles}
                    value={itslogin}
                    defaultValue={cleartype}
                    onChange={(e) => setItsLogin(e)}
                    hideSelectedOptions={false}
                  />
                  {
                    validationerror && !itslogin?.label &&
                    <p className="show_invalid_text" >ITS Login option is required</p>
                  }
                </div>
              </div>
              <div className="col-md-12">
                <label for="Type " className="form-label">
                  Type{" "}
                </label>
                <div className="checkbox_btn">
                  <div className={selectedOption === "Auto" ? "form-check tab1" : "form-check"}>
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexRadioDefault1"
                      value="Auto"
                      checked={selectedOption === "Auto"}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Auto
                    </label>
                  </div>

                  <div className={selectedOption === "Manual" ? "form-check tab1" : "form-check"}>
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexRadioDefault2"
                      value="Manual"
                      checked={selectedOption === "Manual"}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label" for="flexRadioDefault2">
                      Manual
                    </label>
                  </div>
                </div>
              </div>
              <div className="manu-card">
                  <label for="Portion" className="form-label">
                    Notes
                  </label>
                  <div className="new_notes_user">
                    <div className="New_Form_box">
                      <textarea
                        placeholder="Add your comments here..."
                        className={"form-control"}
                        id="Addres"
                        value={notes == null ? '' : notes}
                        onChange={(e) =>
                          handleNotesChange(
                            e)
                        }
                      ></textarea>
                    </div>
                </div>
              </div>
              <div className="manu-card">
                  <label for="Portion" className="form-label">
                    Zone Sheet Notes
                  </label>
                  <div className="new_notes_user">
                    <div className="New_Form_box">
                      <textarea
                        placeholder="Add Zone Sheet comments here..."
                        className={"form-control"}
                        id="Addres"
                        value={zoneSheetNotes == null ? '' : zoneSheetNotes}
                        onChange={(e) =>
                          handleZoneSheetNotesChange(
                            e)
                        }
                      ></textarea>
                    </div>
                </div>
              </div>
              <hr className="Line" />
              <div className="Ingredients_title">
                <h1>Groups</h1>
                {/* <button type="button" className="btn" onClick={RemoveModal}>
                  Add Group
                </button> */}
              </div>
              <div className="group_check">
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("GEN")}
                      onChange={() => handleCheckboxChange("GEN", "3")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      General
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="ADM"
                      name="General"
                      id="flexCheckChecked1"
                      checked={selectedValue.includes("ADM")}
                      onChange={() => handleCheckboxChange("ADM", "1")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked1"
                    >
                      Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="OPT"
                      name="General"
                      id="flexCheckChecked2"
                      checked={selectedValue.includes("OPT")}
                      onChange={() => handleCheckboxChange("OPT", "11")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked2"
                    >
                      Operator
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="ODM"
                      name="Admin"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("ODM")}
                      onChange={() => handleCheckboxChange("ODM", "12")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Operator Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                  <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("IDM")}
                      onChange={() => handleCheckboxChange("IDM", "21")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Ingredient Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PRO"
                      name="MiqaatAdmin"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("PRO")}
                      onChange={() => handleCheckboxChange("PRO", "6")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Procurement
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PRM"
                      name="Scheduling"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("PRM")}
                      onChange={() => handleCheckboxChange("PRM", "14")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Procurement Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MIQ"
                      name="Procurement"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("MIQ")}
                      onChange={() => handleCheckboxChange("MIQ", "15")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Miqaat / Niyaaz
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MTK"
                      name="Miqaat Token"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("MTK")}
                      onChange={() => handleCheckboxChange("MTK", "19")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                       Miqaat / Niyaaz Token
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MDM"
                      name="Inventory"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("MDM")}
                      onChange={() => handleCheckboxChange("MDM", "9")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Miqaat / Niyaaz Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="INV"
                      name="Registration"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("INV")}
                      onChange={() => handleCheckboxChange("INV", "16")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Special
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="FBM"
                      name="Registration"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("FBM")}
                      onChange={() => handleCheckboxChange("FBM", "20")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Feedback Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="FBM"
                      name="Registration"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("QRM")}
                      onChange={() => handleCheckboxChange("QRM", "21")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      QR Code Scanner
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CAT"
                      name="Caterer"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("CAT")}
                      onChange={() => handleCheckboxChange("CAT", "22")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Caterer
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CDM"
                      name="CatererAdmin"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("CDM")}
                      onChange={() => handleCheckboxChange("CDM", "23")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Caterer Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="RDM"
                      name="RequestAdmin"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("RDM")}
                      onChange={() => handleCheckboxChange("RDM", "24")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Request Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
              </div>


              {/* <div className="group_check">
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("GEN")}
                      onChange={() => handleCheckboxChange("GEN", "3")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      General
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CAT"
                      name="General"
                      id="flexCheckChecked1"
                      checked={selectedValue.includes("CAT")}
                      onChange={() => handleCheckboxChange("CAT", "4")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked1"
                    >
                      Cateror Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PKG"
                      name="General"
                      id="flexCheckChecked2"
                      checked={selectedValue.includes("PKG")}
                      onChange={() => handleCheckboxChange("PKG", "2")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked2"
                    >
                      Packaging Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="ADM"
                      name="Admin"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("ADM")}
                      onChange={() => handleCheckboxChange("ADM", "1")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MDM"
                      name="MiqaatAdmin"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("MDM")}
                      onChange={() => handleCheckboxChange("MDM", "9")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Miqaat Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="SCH"
                      name="Scheduling"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("SCH")}
                      onChange={() => handleCheckboxChange("SCH", "7")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Scheduling Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PRO"
                      name="Procurement"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("PRO")}
                      onChange={() => handleCheckboxChange("PRO", "6")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Procurement Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="INV"
                      name="Inventory"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("INV")}
                      onChange={() => handleCheckboxChange("INV", "7")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Inventory Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="REG"
                      name="Registration"
                      id="flexCheckDefault"
                      checked={selectedValue.includes("REG")}
                      onChange={() => handleCheckboxChange("REG", "8")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Registration
                    </label>
                  </div>
                  <p>Member</p>
                </div>
              </div> */}
              <div className="Ingredients_title">
                <h1></h1>
                <div className="Save_btn">
                  <button type="button"
                    id="modal_close_btn"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close">Cancel</button>
                  <button type="submit"
                  >Add user</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>



      {/* edit popup */}
      <div
        className="offcanvas offcanvas-end Dishes_canvas vendor_canvas"
        tabindex="-1"
        id="offcanvasRight_update"
        aria-labelledby="offcanvasRight_update"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            Edit user{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">

          <div className="Dish_Name_list">
            {/* <div className="Img_upload">
              <img src={image} className="img-firud uplode_img" />
              <div>
                <input
                  id="img_upload"
                  type="file"
                  className="vender_input"
                  name="image"
                  onChange={handleChangeImgUrl}
                />
              </div>
              <div className="hover_img">
                <div className="d-flex"><button className="button"><img src={Refrach} className="img-firud hoverlist_img" /></button>
                  <button className="button"><img src={removeimg} className="img-firud hoverlist_img" /></button></div>
              </div>
            </div> */}
            <form className="row g-3" onSubmit={handleupdateSubmit}>


              <div className="col-md-6">
                <div className="Form_box">
                  <label for="ITS Number" className="form-label">
                    ITS Number
                  </label>
                  {/* <input
                    type="number"
                    placeholder="Enter ITS Number"
                    className="form-control"
                    id="ITS number"
                    value={its}
                    onChange={(e) => setIts(e.target.value)}
                  /> */}
                  <input
                    type="text"
                    placeholder="Enter ITS Number"
                    id="itsNumber"
                    value={its}
                    onChange={handleChangeits}
                    // className={`${validationerror && !nineDigitsPattern.test(its) ? "validation_valid form-control" : "form-control"}`}
                    // pattern="\d{9}"
                    className="form-control"
                    title="Please enter exactly 9 digits."
                  />
                  {/* {
                    validationerror && its.length == 10 && 
                    <p className="show_invalid_text" >  ITS Number is containe Min Max 9 digit</p>
                  } */}
                  {/* {validationerror &&
                    !nineDigitsPattern.test(its) &&
                    <p className="show_invalid_text" >  ITS Number is containe Min Max 9 digit</p>} */}
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Addres" className="form-label">
                    Designation
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Designation"
                    className={"form-control"}
                    // className={`${validationerror && !address ? "validation_valid form-control" : "form-control"}`}
                    id="Addres"
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                  />
                  {/* {
                    validationerror && !address &&
                    <p className="show_invalid_text" >    Designation is required</p>
                  } */}
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Name" className="form-label">
                    {" "}
                    First Name
                  </label>
                  <input
                    type="text"
                    placeholder=" Enter First  Name"
                    id="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className={`${validationerror && !name ? "validation_valid form-control" : "form-control"}`}
                  />
                  {
                    validationerror && !name &&
                    <p className="show_invalid_text" >Name is required</p>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Name" className="form-label">
                    {" "}
                    Last Name
                  </label>
                  <input
                    type="text"
                    placeholder=" Enter Name"
                    id="Name"
                    value={last_name}
                    onChange={(e) => setLastName(e.target.value)}
                    className={`${validationerror && !last_name ? "validation_valid form-control" : "form-control"}`}
                  />
                  {
                    validationerror && !last_name &&
                    <p className="show_invalid_text" >Name is required</p>
                  }
                </div>
              </div>

              <div className="col-md-6">
                <div className="Form_box">
                  <label for="ContactPhone" className="form-label">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    placeholder="Enter phone Number"
                    // className={`${validationerror && !mobilenumberregex.test(phone) ? "validation_valid form-control" : "form-control"}`}
                    className="form-control"
                    id="ContactPhone"
                    value={phone}
                    onChange={handlePhoneChange2}
                  />
                  {/* {
                    validationerror && !mobilenumberregex.test(phone) &&
                    <p className="show_invalid_text" >    Phone Number is required</p>
                  } */}
                </div>
              </div>

              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Zone" className="form-label">
                    Zone
                  </label>

                  <Select
                    options={zoneListData}
                    className="dropdown"
                    placeholder="Select Zone"
                    id="inputrice"
                    styles={colourStyles}
                    value={zoneListData.filter(function (option) {
                      return option.value === zoneid;
                    })}
                    onChange={(e) => setZoneid(e.value)}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Portion" className="form-label">
                    Portion
                  </label>

                  <Select
                    options={portionListData}
                    className="dropdown"
                    placeholder="Select  Portion"
                    id="inputrice"
                    styles={colourStyles}
                    value={portionListData.filter(function (option) {
                      return option.value === portionid;
                    })}
                    onChange={(e) => setPortionid(e.value)}

                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Email" className="form-label">
                    Email
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Email Address"
                    className={"form-control"}
                    id="Addres"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                  {/* {
                    validationerror && !email &&
                    <p className="show_invalid_text" >   Email is required</p>
                  } */}
                </div>
              </div>

              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Portion" className="form-label">
                    Default Portion
                  </label>
                  <Select
                    options={portionListData}
                    // className={`${validationerror && !portionid ? "validation_valid dropdown" : "dropdown"}`}
                    className="dropdown"
                    placeholder="Select Default Portion"
                    id="inputrice"
                    styles={colourStyles}
                    value={portionListData.filter(function (option) {
                      return option.value === defaultportionid;
                    })}
                    onChange={(e) => setDefaultPortionid(e.value)}
                  />
                  {
                    validationerror && !defaultportionid &&
                    <p className="show_invalid_text" >Default Portion is required</p>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <div className="Form_box">
                  <label for="Portion" className="form-label">
                    ITS LOGIN
                  </label>
                  <Select
                    options={ItsListData}
                    // className={`${validationerror && !portionid ? "validation_valid dropdown" : "dropdown"}`}
                    className="dropdown"
                    placeholder="Select ITS Login Option"
                    id="inputrice"
                    styles={colourStyles}
                    value={ItsListData.filter(function (option) {
                      return option.label === itslogin;
                    })}
                    defaultValue={cleartype}
                    onChange={(e) => setItsLogin(e?.label)}
                    hideSelectedOptions={false}
                  />
                  {
                    validationerror && !itslogin &&
                    <p className="show_invalid_text" >ITS Login Option is required</p>
                  }
                </div>
              </div>
              <div className="col-md-6">
                <label for="Type " >
                  Type{" "}
                </label>
                <div className="checkbox_btn">
                  <div className={selectedOption === "Auto" ? "form-check tab1" : "form-check"}>
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexRadioDefault11"
                      value="Auto"
                      defaultChecked={selectedOption === "Auto"}
                      checked={selectedOption === "Auto"}
                      onChange={handleRadioChange2}
                    />
                    <label className="form-check-label" for="flexRadioDefault1">
                      Auto
                    </label>
                  </div>
                  <div className={selectedOption === "Manual" ? "form-check tab1" : "form-check"}>
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexRadioDefault12"
                      value="Manual"
                      defaultChecked={selectedOption === "Manual"}
                      checked={selectedOption === "Manual"}
                      onChange={handleRadioChange2}
                    />
                    <label className="form-check-label" for="flexRadioDefault2">
                      Manual
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <label for="Status">
                  Status{" "}
                  {isActive == '1'
                    ? <span className="user-status-badge user-status-active">ACTIVE</span>
                    : <span className="user-status-badge user-status-inactive">INACTIVE</span>
                  }
                </label>
                <div className="checkbox_btn">
                  <div className={isActive == '1' ? "form-check tab1" : "form-check"}>
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexRadioActive"
                      value="1"
                      checked={isActive == '1'}
                      onChange={() => setIsActive('1')}
                    />
                    <label className="form-check-label" htmlFor="flexRadioActive">
                      Active
                    </label>
                  </div>
                  <div className={isActive != '1' ? "form-check tab1" : "form-check"}>
                    <input
                      className="form-check-input"
                      type="radio"
                      id="flexRadioInactive"
                      value="0"
                      checked={isActive != '1'}
                      onChange={() => setIsActive('0')}
                    />
                    <label className="form-check-label" htmlFor="flexRadioInactive">
                      In Active
                    </label>
                  </div>
                </div>
              </div>
              <div className="manu-card">
                  <label for="Portion" className="form-label">
                     Notes
                  </label>
                  <div className="new_notes_user">
                    <div className="New_Form_box">
                      <textarea
                        placeholder="Add your comments here..."
                        className={"form-control"}
                        id="Addres"
                        value={notes == null ? '' : notes}
                        onChange={(e) =>
                          handleNotesChange(
                            e)
                        }
                      ></textarea>
                    </div>
                </div>
              </div>
              <div className="manu-card">
                  <label for="Portion" className="form-label">
                    Zone Sheet Notes
                  </label>
                  <div className="new_notes_user">
                    <div className="New_Form_box">
                      <textarea
                        placeholder="Add Zone Sheet comments here..."
                        className={"form-control"}
                        id="Addres"
                        value={zoneSheetNotes == null ? '' : zoneSheetNotes}
                        onChange={(e) =>
                          handleZoneSheetNotesChange(
                            e)
                        }
                      ></textarea>
                    </div>
                </div>
              </div>
              <hr className="Line" />
              <div className="Ingredients_title">
                <h1>Groups</h1>
                {/* <button className="btn" onClick={RemoveModal}>
                  Add Group
                </button> */}
              </div>

              <div className="group_check">
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("GEN")}
                      onChange={() => handleupdateboxChange("GEN", "3")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      General
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="ADM"
                      name="General"
                      id="flexCheckChecked1"
                      checked={selectedValueupdate.includes("ADM")}
                      onChange={() => handleupdateboxChange("ADM", "1")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked1"
                    >
                      Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="OPT"
                      name="General"
                      id="flexCheckChecked2"
                      checked={selectedValueupdate.includes("OPT")}
                      onChange={() => handleupdateboxChange("OPT", "11")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked2"
                    >
                      Operator
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="ODM"
                      name="Admin"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("ODM")}
                      onChange={() => handleupdateboxChange("ODM", "12")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Operator Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                  <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("IDM")}
                      onChange={() => handleupdateboxChange("IDM", "21")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Ingredient Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PRO"
                      name="MiqaatAdmin"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("PRO")}
                      onChange={() => handleupdateboxChange("PRO", "6")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Procurement
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PRM"
                      name="Scheduling"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("PRM")}
                      onChange={() => handleupdateboxChange("PRM", "14")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Procurement Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MIQ"
                      name="Procurement"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("MIQ")}
                      onChange={() => handleupdateboxChange("MIQ", "15")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Miqaat / Niyaaz
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MDM"
                      name="Inventory"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("MDM")}
                      onChange={() => handleupdateboxChange("MDM", "9")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Miqaat / Niyaaz Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MTK"
                      name="Miqaat Token"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("MTK")}
                      onChange={() => handleupdateboxChange("MTK", "19")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                       Miqaat / Niyaaz Token
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="INV"
                      name="Registration"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("INV")}
                      onChange={() => handleupdateboxChange("INV", "16")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Special
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                  <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("FBM")}
                      onChange={() => handleupdateboxChange("FBM", "3")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Feedback Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                  <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("QRM")}
                      onChange={() => handleupdateboxChange("QRM", "21")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      QR Code Scanner
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CAT"
                      name="Caterer"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("CAT")}
                      onChange={() => handleupdateboxChange("CAT", "22")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Caterer
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CDM"
                      name="CatererAdmin"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("CDM")}
                      onChange={() => handleupdateboxChange("CDM", "23")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Caterer Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="RDM"
                      name="RequestAdmin"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("RDM")}
                      onChange={() => handleupdateboxChange("RDM", "24")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Request Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
              </div>

              {/* <div className="group_check">
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="GEN"
                      name="General"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("GEN")}
                      onChange={() => handleupdateboxChange("GEN", "3")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      General
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="CAT"
                      name="General"
                      id="flexCheckChecked1"
                      checked={selectedValueupdate.includes("CAT")}
                      onChange={() => handleupdateboxChange("CAT", "4")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked1"
                    >
                      Cateror Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PKG"
                      name="General"
                      id="flexCheckChecked2"
                      checked={selectedValueupdate.includes("PKG")}
                      onChange={() => handleupdateboxChange("PKG", "2")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked2"
                    >
                      Packaging Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="ADM"
                      name="Admin"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("ADM")}
                      onChange={() => handleupdateboxChange("ADM", "1")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="MDM"
                      name="MiqaatAdmin"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("MDM")}
                      onChange={() => handleupdateboxChange("MDM", "9")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Miqaat Admin
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="SCH"
                      name="Scheduling"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("SCH")}
                      onChange={() => handleupdateboxChange("SCH", "7")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Scheduling Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="PRO"
                      name="Procurement"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("PRO")}
                      onChange={() => handleupdateboxChange("PRO", "6")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Procurement Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="INV"
                      name="Inventory"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("INV")}
                      onChange={() => handleupdateboxChange("INV", "7")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Inventory Group
                    </label>
                  </div>
                  <p>Member</p>
                </div>
                <div className="form-check">
                  <div>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value="REG"
                      name="Registration"
                      id="flexCheckDefault"
                      checked={selectedValueupdate.includes("REG")}
                      onChange={() => handleupdateboxChange("REG", "8")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefauhandleCheckboxChangelt"
                    >
                      Registration
                    </label>
                  </div>
                  <p>Member</p>
                </div>
              </div> */}
              <div className="Ingredients_title">
                <h1></h1>
                <div className="Save_btn">
                  <button type="button" id="modal_close_btn2" data-bs-dismiss="offcanvas"
                    aria-label="Close">Cancel</button>
                  <button type="submit">Update User</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Modal
          isOpen={RemoveIsOpen}
          onAfterOpen={RemoveOpenModal}
          onRequestClose={RemovecloseModal}
          style={customStyles}
          contentLabel="Remove Modal"
          id="edit_popup_user"
        >
          <div className="popup_modal">
            <div className="d-flex justify-content-between align-items-center">
              <div className="Popup_heding">
                <img src={multiuser} className="img-firud" />
                &nbsp; &nbsp; &nbsp;&nbsp;
                <div className="edit_div">
                  {/* <h1>Add Group </h1> */}
                </div>
              </div>
              <button onClick={RemovecloseModal}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M6.99967 8.19364L1.82142 13.3719C1.65149 13.5418 1.45257 13.6268 1.22467 13.6268C0.996772 13.6268 0.797855 13.5418 0.627922 13.3719C0.458005 13.202 0.373047 13.0031 0.373047 12.7752C0.373047 12.5473 0.458005 12.3483 0.627922 12.1784L5.8062 7.00016L0.627922 1.82191C0.458005 1.65198 0.373047 1.45306 0.373047 1.22516C0.373047 0.99726 0.458005 0.798344 0.627922 0.62841C0.797855 0.458494 0.996772 0.373535 1.22467 0.373535C1.45257 0.373535 1.65149 0.458494 1.82142 0.62841L6.99967 5.80668L12.1779 0.62841C12.3479 0.458494 12.5468 0.373535 12.7747 0.373535C13.0026 0.373535 13.2015 0.458494 13.3714 0.62841C13.5413 0.798344 13.6263 0.99726 13.6263 1.22516C13.6263 1.45306 13.5413 1.65198 13.3714 1.82191L8.19315 7.00016L13.3714 12.1784C13.5413 12.3483 13.6263 12.5473 13.6263 12.7752C13.6263 13.0031 13.5413 13.202 13.3714 13.3719C13.2015 13.5418 13.0026 13.6268 12.7747 13.6268C12.5468 13.6268 12.3479 13.5418 12.1779 13.3719L6.99967 8.19364Z"
                    fill="#2E294E"
                  />
                </svg>
              </button>
            </div>
            <div className="edit_from">
              <form>
                <div className="form-group">
                  <label>Group Name</label>
                  <input
                    className="form-control"
                    type="text"
                    value=""
                    name="General"
                    id="Enter group name"
                  />
                </div>
                <div className="form-group">
                  <label>Role</label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                  >
                    <option selected>Select Role </option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>

                <div className="Thali_page_btn_from">
                  <button className="btn thali_btn" onClick={RemovecloseModal}>
                    Cancel
                  </button>
                  &nbsp; &nbsp; &nbsp;
                  <button className="btn thali_btn">Add Group</button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </div>

      <Modal
        isOpen={RemoveuserIsOpen}
        onAfterOpen={RemoveuserOpenModal}
        onRequestClose={RemoveusercloseModal}
        style={customStyles}
        contentLabel="Remove Modal"
        id="edit_popup"
      >
        <div className="popup_modal">
          <div className="Remove_from">
            <img src={remove} className="img-firud" />
            <h1>Remove User</h1>
            <h6>{its} - {name} {last_name}</h6>
            <h1>&nbsp;</h1>
            <h6>
              Do you really want to remove this user?
            </h6>
            <h6>
              This action cannot be undone!
            </h6>
            <h1>&nbsp;</h1>
            <div className="Thali_page_btn_from btn-div">
              <button onClick={RemoveusercloseModal} className="btn thali_btn">
                Cancel
              </button>
              <button onClick={() => RemoveuserModaldata()} className="btn thali_btn">
                Remove User
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        id= {isMobile() ? "edit_popup_user_mobile" : "edit_user_register"} //edit_popup_user_mobile
      >
        <div className="popup_modal">
          <div className="d-flex justify-content-between align-items-center">
            <div className="Popup_heding">
              <img src={editicon} className="img-firud" />
              &nbsp; &nbsp; &nbsp;&nbsp;
              <div className="edit_div">
                <h1>View User Details &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &emsp; &emsp; &emsp; &emsp; {registerationUserDetail} </h1>
                <p>
                  To view thaali registered data and
                  add/remove or update portion
                </p>
              </div>
            </div>
            <button onClick={closeModal}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M6.99967 8.19364L1.82142 13.3719C1.65149 13.5418 1.45257 13.6268 1.22467 13.6268C0.996772 13.6268 0.797855 13.5418 0.627922 13.3719C0.458005 13.202 0.373047 13.0031 0.373047 12.7752C0.373047 12.5473 0.458005 12.3483 0.627922 12.1784L5.8062 7.00016L0.627922 1.82191C0.458005 1.65198 0.373047 1.45306 0.373047 1.22516C0.373047 0.99726 0.458005 0.798344 0.627922 0.62841C0.797855 0.458494 0.996772 0.373535 1.22467 0.373535C1.45257 0.373535 1.65149 0.458494 1.82142 0.62841L6.99967 5.80668L12.1779 0.62841C12.3479 0.458494 12.5468 0.373535 12.7747 0.373535C13.0026 0.373535 13.2015 0.458494 13.3714 0.62841C13.5413 0.798344 13.6263 0.99726 13.6263 1.22516C13.6263 1.45306 13.5413 1.65198 13.3714 1.82191L8.19315 7.00016L13.3714 12.1784C13.5413 12.3483 13.6263 12.5473 13.6263 12.7752C13.6263 13.0031 13.5413 13.202 13.3714 13.3719C13.2015 13.5418 13.0026 13.6268 12.7747 13.6268C12.5468 13.6268 12.3479 13.5418 12.1779 13.3719L6.99967 8.19364Z"
                  fill="#2E294E"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className="Registers_tabal">
          {/* <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">
                  {" "}
                  <span className="thali_table">Day & Date</span>
                </th>
                <th scope="col">
                  <span className="thali_table">Portion</span>
                </th>
                <th scope="col">
                  <span className="thali_table">Zone</span>
                </th>
                <th scope="col">
                  <span className="thali_table">Roti</span>
                </th>
                <th scope="col">
                  <span className="thali_table">RIce</span>
                </th>
                <th scope="col">
                  <span className="thali_table">Thali Registerd</span>
                </th>
              </tr>
            </thead>
            <tbody> */}
          <div className="card-flex">
            {ragisterView.map((item, index) => {
              // const date = new Date(item.schedule_day);
              const date = convertDateForIos(item.schedule_day)
              const day = date.toLocaleString("en-US", { weekday: "long" });
              const month = date.toLocaleString("en-US", { month: "long" });
              const numericDate = date.getDate();
              const twoDigitYear = date.getFullYear();
              const menuArray = parseMenuDishNames(item);
              const scheduleDishes = parseScheduleDishes(item);
              // Determine if this is a Miqaat day
              const isMiqaat = item.schedule_type === "MIQAAT";
              const portionOptions = isMiqaat ? miqaatPortionListData : portionListData;

              return (
                <div className={isMiqaat ? "Thaali-myBg" : ""} key={item.id}>
                <div className="card" style={isMiqaat ? {background: '#D3E3FD'} : {}}>
                  <div className="manu-card">
                    <div className="user_Calendar_card">
                      {" "}
                      <h6>{day}</h6>
                      <h1>{numericDate}</h1>
                      <p>
                        {month}, {twoDigitYear}
                      </p>
                      <p className="hijri_date">
                        <span className="hijri_day">{getHijriParts(date).day}</span>
                        <span className="hijri_month">{getHijriParts(date).month}</span>
                      </p>
                    </div>
                  </div>
                  <div className="reg-menu-div spacediv spacemargin">
                    {/* Miqaat Banner */}
                    {isMiqaat && (
                      <div className="thali-checkbox">
                        <h5 className="miqaat-jaman-thaali-heding">MIQAAT</h5>
                      </div>
                    )}
                    <div className="mp-dish-portion-header-row">
                      <h5 class="thali-user-heding">Menu:</h5>
                      {!isMiqaat && (
                        <h5 class="thali-user-heding">Portion</h5>
                      )}
                    </div>
                    <ul className="thalireg_user_menu_list">
                      {menuArray
                        ?.map((dish_name, origIdx) => ({ dish_name, origIdx }))
                        .filter(
                          ({ dish_name }) => dish_name.trim() !== ""
                        ) // Remove blank items
                        // Dishes with a portion size to pick first, rice/roti
                        // Yes-No toggle dishes last - sort is stable so each
                        // group otherwise keeps its original menu order.
                        .sort((a, b) => {
                          const aSkippable = !isMiqaat && isSkippableRiceRotiDish(item, a.dish_name);
                          const bSkippable = !isMiqaat && isSkippableRiceRotiDish(item, b.dish_name);
                          return aSkippable === bSkippable ? 0 : aSkippable ? 1 : -1;
                        })
                        .map(({ dish_name, origIdx }) => {
                          const skippable = !isMiqaat && isSkippableRiceRotiDish(item, dish_name);
                          const showPortionPicker = !isMiqaat && !skippable;
                          const dpKey = `${index}_${origIdx}`;
                          const dish = findDishMatch(scheduleDishes, dish_name);
                          const dishPortion = dish && !isEmptyPortionCode(dish.portion_type_code) ? dish.portion_type_code : null;
                          const defaultDishPortion = dishPortion ?? resolveDayPortion(item);
                          const overridePortion = dishPortionSelections[dpKey];
                          const selectedPortion = overridePortion !== undefined ? overridePortion : defaultDishPortion;
                          const isRowDisabled = item.is_active != 1;
                          return (
                            <li key={origIdx} className="mp-dish-portion-row">
                              <span className="mp-dish-portion-name">{dish_name}</span>
                              {showPortionPicker && (
                                <div className="mp-dish-portion-select">
                                  <Select
                                    options={portionListData}
                                    className="dropdown"
                                    placeholder="Portion"
                                    styles={dishPortionSelectStyles}
                                    isDisabled={isRowDisabled}
                                    onChange={(selectedOption) =>
                                      setDishPortionSelections((prev) => ({ ...prev, [dpKey]: selectedOption.value }))
                                    }
                                    value={
                                      selectedPortion
                                        ? portionListData.find((opt) => String(opt.value) === String(selectedPortion)) || null
                                        : null
                                    }
                                  />
                                </div>
                              )}
                            </li>
                          );
                        })}

                      {item.fateha_name ? (
                        <>
                          <h5 class="thali-user-heding"></h5>
                          <h5 class="thali-user-heding">Fateha Name</h5>
                          <li>{item.fateha_name}</li>
                        </>
                      ) : (
                        <></>
                      )}
                    </ul>
                  </div>
                  {/* Main/day-level Portion (labeled "# RSVP" for Miqaat) - sets the
                      whole day's portion (item.portion_type_code). For FMB Thali,
                      the displayed value falls back to the user's own default
                      portion via resolveDayPortion, same as the submit-time
                      resolution below. The per-dish pickers above still let any
                      individual dish override this default - they're unaffected. */}
                  <div className="manu-card">
                    {" "}
                    <h5 className="thali-user-heding">{isMiqaat ? "# RSVP" : "Portion"}</h5>
                    <ul className="thali_menu_list view_Registeruser">
                      <li className="Form_box">
                        <Select
                          options={portionOptions}
                          className="dropdown"
                          placeholder={isMiqaat ? "Select RSVP" : "Select Portion"}
                          id="inputrice"
                          styles={colourStyles}
                          onChange={(selectedOption) =>
                            handlezoneIdChange2(index, selectedOption.value)
                          }
                          value={
                            (() => {
                              const code = isMiqaat ? item.portion_type_code : resolveDayPortion(item);
                              return !isEmptyPortionCode(code)
                                ? portionOptions.find((option) => option.value === code) || null
                                : null;
                            })()
                          }
                        />
                      </li>
                    </ul>
                  </div>
                  {/* Zone - only show for FMB Thali */}
                  {!isMiqaat && (
                  <div className="manu-card">
                    <h5 className="thali-user-heding">Zone</h5>
                    <ul className="thali_menu_list view_Registeruser">
                      <li className="Form_box">
                        <Select
                          options={zoneListData}
                          className="dropdown"
                          placeholder="Select Zone"
                          id="inputrice"
                          styles={colourStyles}
                          onChange={(selectedOption) =>
                            handlezoneIdChange(index, selectedOption.value)
                          }
                          value={
                            item.pickup_location_code
                              ? zoneListData.find(
                                  (option) =>
                                    option.value === item.pickup_location_code
                                )
                              : null
                          }
                        />
                      </li>
                    </ul>
                  </div>
                  )}
                  {/* Roti - only show for FMB Thali */}
                  {!isMiqaat && (
                  <div className="manu-card">
                    <h5 className="thali-user-heding">Roti</h5>
                    <ul className="thali_menu_list">
                      <li>
                        {item.allow_skip_roti == "0" ? (
                          <>NA</>
                        ) : (
                          <>
                            <div className="Register_user_input">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id={`roti_check_${index}`}
                                  value={item.want_roti}
                                  checked={item.want_roti == "1"}
                                  onChange={(e) =>
                                    handleRotiChange(
                                      e,
                                      index,
                                      item.want_roti == "1"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </li>
                    </ul>
                  </div>
                  )}
                  {/* Rice - only show for FMB Thali */}
                  {!isMiqaat && (
                  <div className="manu-card">
                    <h5 className="thali-user-heding">Rice</h5>
                    <ul className="thali_menu_list">
                      <li>
                        {item.allow_skip_rice == "0" ? (
                          <>NA</>
                        ) : (
                          <>
                            <div className="Register_user_input">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id={`rice_check_${index}`}
                                  value={item.want_rice}
                                  checked={item.want_rice == "1"}
                                  onChange={(e) =>
                                    handleRiceChange(
                                      e,
                                      index,
                                      item.want_rice == "1"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </li>
                    </ul>
                  </div>
                  )}
                  {/* Mithas - only show for FMB Thali */}
                  {!isMiqaat && (
                  <div className="manu-card">
                    <h5 className="thali-user-heding">Mithas</h5>
                    <ul className="thali_menu_list">
                      <li>
                        {item.allow_skip_mithas == "0" ? (
                          <>NA</>
                        ) : (
                          <>
                            <div className="Register_user_input">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id={`mithas_check_${index}`}
                                  value={item.want_mithas}
                                  checked={item.want_mithas == "1"}
                                  onChange={(e) =>
                                    handleMithasChange(
                                      e,
                                      index,
                                      item.want_mithas == "1"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </li>
                    </ul>
                  </div>
                  )}
                  <div className="manu-card">
                    <h5 className="thali-user-heding">{isMiqaat ? "Attending" : "Register Thaali"}</h5>
                    <ul className="thali_menu_list">
                      <li>
                        <div className="THALI-REGISTERED-check">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`is_active_${index}`}
                              value={item.is_active}
                              checked={item.is_active == true}
                              onChange={(e) =>
                                handleTHALIChange(
                                  e,
                                  index,
                                  item.is_active === true
                                )
                              }
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
              <div className="manu-card">
                  <h5 className="thali-user-heding">Comments</h5>
                  <div className="new_thali_menu_list">
                    <div className="New_Form_box">
                      <textarea
                        placeholder="Add your comments here..."
                        className="form-control"
                        id="TestlistNew"
                        value={item.source == 0 ? '' : item.source}
                        onChange={(e) =>
                          handleSourceChange(
                            e,
                            index
                          )
                        }
                      ></textarea>
                    </div>
                </div>
              </div>
              </div>
              </div>
              );
            })}
          </div>
          {/* </tbody>
          </table> */}
        </div>
        <div className="Thali_page_btn_from">
          <button type="button" onClick={closeModal} className="btn thali_btn" disabled={isSubmitting}>
            Cancel
          </button>
          &nbsp; &nbsp; &nbsp;
          <button className="btn thali_btn" onClick={handleSubmituser} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Updating...
              </>
            ) : (
              "Update Details"
            )}
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={notifModalOpen}
        onRequestClose={() => setNotifModalOpen(false)}
        style={customStyles}
        contentLabel="Send Notification"
        id="notif_popup"
      >
        <div className="popup_modal">
          <div className="Remove_from">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" style={{ marginBottom: 8 }}>
              <path d="M20 4H4C2.897 4 2 4.897 2 6v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2-8 5-8-5h16zm0 12H4V8.868l8 5 8-5V18z" fill="#5C5EC1"/>
            </svg>
            <h1>Send Notification</h1>
            <h6>{notifUser?.its_id} — {notifUser?.designation} {notifUser?.first_name} {notifUser?.last_name}</h6>
          </div>
          <form className="row g-3" style={{ marginTop: 8 }}>
            <div className="col-md-12">
              <div className="Form_box">
                <label htmlFor="notifTitle" className="form-label">
                  Title <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  id="notifTitle"
                  type="text"
                  className="form-control"
                  placeholder="Enter notification title"
                  value={notifTitle}
                  onChange={(e) => setNotifTitle(e.target.value)}
                  style={{ border: "1px solid #ced4da", padding: "8px 12px" }}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="Form_box">
                <label htmlFor="notifBody" className="form-label">
                  Body <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  id="notifBody"
                  className="form-control"
                  rows={3}
                  placeholder="Enter notification message"
                  value={notifBody}
                  onChange={(e) => setNotifBody(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="Thali_page_btn_from btn-div">
                <button type="button" onClick={() => setNotifModalOpen(false)} className="btn thali_btn">
                  Cancel
                </button>
                <button type="button" onClick={handleSendNotification} className="btn thali_btn" disabled={notifLoading}>
                  {notifLoading ? (
                    <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Sending...</>
                  ) : (
                    "Send"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}
